import * as Api from '@ViewModels';
import { animated, useSprings } from '@react-spring/web';
import * as React from 'react';
import Particles from 'react-particles';
import { loadFull } from 'tsparticles';
import { Engine, ISourceOptions } from 'tsparticles-engine';
import { loadEmittersPlugin } from 'tsparticles-plugin-emitters';
import { loadBubblesPreset } from 'tsparticles-preset-bubbles';
import { SvgIcon } from '../../../../web/components/svgs/icons/SvgIcon';
import { SlotMachineSymbol } from '../SlotMachineSymbol';
import BubbleImageUrl from './daisyBubble.png';
import { styleSheet } from './styles';

interface IBoozeCruiseSymbolProps {
	height: number;
	symbolType: Api.SlotMachineSymbol;
}

export const BoozeCruiseSymbol: React.FC<IBoozeCruiseSymbolProps> = props => {
	const { height, symbolType } = props;
	const style: React.CSSProperties = { height, width: 'auto' };
	switch (symbolType) {
		case Api.SlotMachineSymbol.Cherry: {
			style.width = (style.width as number) + 10;
			break;
		}
		case Api.SlotMachineSymbol.Tiger: {
			style.width = (style.width as number) + 5;
			break;
		}
		default: {
			break;
		}
	}

	const styleProvider = (s: React.CSSProperties) => {
		return {
			...s,
			...style,
		};
	};

	return <SlotMachineSymbol style={styleProvider} styles={[styleSheet.symbol]} type={symbolType} />;
};

export const Background: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<SvgIcon fill='none' height={3481} width={3481} {...props}>
			<g opacity='.49' filter='url(#backgroundElement-a)'>
				<circle cx='1740.5' cy='1740.5' r='1604.5' fill='url(#backgroundElement-b)' />
			</g>
			,
			<g filter='url(#backgroundElement-c)'>
				<circle cx='1740.5' cy='1740.5' r='1264.5' fill='url(#backgroundElement-d)' />
			</g>
			,
			<g filter='url(#backgroundElement-e)'>
				<circle cx='1740.5' cy='1740.5' r='1059.5' fill='url(#backgroundElement-f)' />
			</g>
			,
			<defs>
				<radialGradient
					id='backgroundElement-b'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='scale(2957.74 3472.34) rotate(90 .271 .317)'
				>
					<stop stopColor='#D7EBF7' />
					<stop offset='.413' stopColor='#00AAE8' />
					<stop offset='.55' stopColor='#046CB6' stopOpacity='.921' />
					<stop offset='.763' stopColor='#00528C' stopOpacity='.603' />
					<stop offset='.864' stopColor='#002F51' stopOpacity='.22' />
					<stop offset='1' stopColor='#046CB6' stopOpacity='.522' />
				</radialGradient>
				<radialGradient
					id='backgroundElement-d'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='matrix(0 2736.54 -2330.98 0 1740.5 493.51)'
				>
					<stop stopColor='#D7EBF7' />
					<stop offset='.413' stopColor='#00AAE8' />
					<stop offset='.55' stopColor='#046CB6' stopOpacity='.921' />
					<stop offset='.763' stopColor='#00528C' stopOpacity='.603' />
					<stop offset='.864' stopColor='#002F51' stopOpacity='.22' />
					<stop offset='1' stopColor='#046CB6' stopOpacity='.522' />
				</radialGradient>
				<radialGradient
					id='backgroundElement-f'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='scale(1953.09 2292.89) rotate(90 .294 .597)'
				>
					<stop stopColor='#D7EBF7' />
					<stop offset='.413' stopColor='#00AAE8' />
					<stop offset='.55' stopColor='#046CB6' stopOpacity='.921' />
					<stop offset='.763' stopColor='#00528C' stopOpacity='.603' />
					<stop offset='.864' stopColor='#002F51' stopOpacity='.22' />
					<stop offset='1' stopColor='#046CB6' stopOpacity='.522' />
				</radialGradient>
				<filter
					id='backgroundElement-a'
					x='.086'
					y='.086'
					width='3480.83'
					height='3480.83'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
					<feGaussianBlur stdDeviation='67.957' result='effect1_foregroundBlur_1_3' />
				</filter>
				<filter
					id='backgroundElement-c'
					x='340.086'
					y='340.086'
					width='2800.83'
					height='2800.83'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
					<feGaussianBlur stdDeviation='67.957' result='effect1_foregroundBlur_1_3' />
				</filter>
				<filter
					id='backgroundElement-e'
					x='545.086'
					y='545.086'
					width='2390.83'
					height='2390.83'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
					<feGaussianBlur stdDeviation='67.957' result='effect1_foregroundBlur_1_3' />
				</filter>
			</defs>
		</SvgIcon>
	);
};

export const Ocean: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<SvgIcon fill='none' height={1483} width={1462} {...props}>
			<rect x='.5' width='1461' height='1483' rx='730.5' fill='url(#ocean__a)' />
			<defs>
				<radialGradient
					id='ocean__a'
					cx='0'
					cy='0'
					r='1'
					gradientUnits='userSpaceOnUse'
					gradientTransform='matrix(0 1604.7 -1346.61 0 731 10.268)'
				>
					<stop stopColor='#D7EBF7' />
					<stop offset='.413' stopColor='#00AAE8' />
					<stop offset='.55' stopColor='#046CB6' />
					<stop offset='.783' stopColor='#00528C' />
					<stop offset='.907' stopColor='#002F51' />
					<stop offset='1' stopColor='#046CB6' />
				</radialGradient>
			</defs>
		</SvgIcon>
	);
};

export const Fish: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	const fishGroups = [
		<animated.g key='Fish_10768'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M451.738 817C453.738 822.396 456.205 827.676 457.558 833.229C458.334 836.414 459.37 837.516 462.529 838.011C486.105 841.702 506.255 852.044 522.539 869.654C523.158 870.323 523.672 871.087 524.5 872.149C503.108 889.848 479.345 900.733 451.416 900.87C447.421 900.889 445.064 902.081 442.361 905.061C438.285 909.554 433.135 913.07 428.44 917C427.762 916.407 427.085 915.814 426.407 915.221C429.474 910.248 432.54 905.276 435.787 900.012C402.636 893.806 377.927 874.892 357.5 847.681C390.054 842.751 421.106 834.382 453.444 836.817C451.847 830.256 450.345 824.088 448.844 817.921C449.808 817.615 450.772 817.307 451.738 817'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M354.5 844C335.353 843.671 317.064 826.955 311.5 805C330.732 812.813 343.756 826.447 354.5 844'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M353.5 849.327C337.683 857.86 321.172 860.459 303.777 855.497L303.5 853.189C320.061 851.126 336.622 849.062 353.183 847C353.287 847.775 353.394 848.551 353.5 849.327'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10766'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M228.607 573.938C241.377 595.513 246.467 619.565 241.792 646C239.873 645.711 238.232 645.596 236.659 645.208C210.809 638.823 188.795 626.28 172.207 604.85C171.102 603.423 168.468 602.599 166.514 602.541C159.591 602.337 152.994 601.346 145.5 596.292C152.939 595.406 158.774 594.711 165.026 593.966C149.441 564.182 148.872 533.099 157.513 500C181.39 522.544 207.193 541.757 225.314 568.54C229.421 563.237 233.397 558.104 237.373 552.969C238.136 553.471 238.899 553.974 239.66 554.476C236.19 560.588 232.718 566.7 228.607 573.938'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M158.351 496C146.532 480.645 148.277 455.236 162.104 438C168.261 457.941 165.469 476.692 158.351 496'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M152.696 499C136.508 491.623 124.239 480.318 117.5 463.477L118.957 462C130.805 473.78 142.652 485.558 154.5 497.336C153.898 497.891 153.297 498.446 152.696 499'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10758'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M711.5 277.005C695.05 282.116 678.729 284.023 662.137 282.177C653.302 281.195 644.567 279.168 635.866 277.253C632.973 276.618 631.273 276.946 628.933 279.023C624.698 282.783 619.728 285.719 615.066 289C614.52 288.302 613.973 287.606 613.427 286.909C617.76 282.955 622.092 278.999 626.851 274.654C597.553 263.992 572.672 245.496 545.5 228.636C577.282 216.38 608.815 212.876 641.577 220.615C641.099 215.378 640.678 210.759 640.153 205C646.431 208.87 649.041 214.033 650.216 219.66C650.961 223.225 652.761 224.59 655.75 225.83C678.247 235.169 695.673 250.406 708.251 271.184C709.311 272.936 710.252 274.76 711.5 277.005'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M541.5 230.966C522.907 239.783 504.615 244.422 484.5 242.613C496.859 229.679 523.366 224.082 541.5 230.966'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M503.555 203C519.29 205.481 532.274 212.852 542.5 225.124C542.147 225.749 541.793 226.375 541.44 227C528.46 219.621 515.481 212.244 502.5 204.865C502.853 204.244 503.203 203.622 503.555 203'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10772'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M933.79 453.756C934.183 458.2 935.259 462.721 934.778 467.066C934.272 471.647 935.481 474.792 938.301 478.296C951.258 494.408 958.865 512.951 961.792 533.442C962.189 536.224 962.22 539.06 962.5 543C956.349 541.177 950.911 539.827 945.654 537.958C929.839 532.333 916.09 523.261 903.977 511.684C901.28 509.107 899.153 508.067 895.174 509.465C890.99 510.937 886.189 510.632 881.658 511.103C881.527 510.354 881.396 509.604 881.265 508.855C886.07 507.474 890.876 506.093 896.541 504.465C876.3 482.223 862.825 455.505 846.5 429C877.467 433.587 904.135 444.779 927.58 466.055C928.229 463.718 928.684 461.767 929.32 459.877C930.034 457.756 930.912 455.691 931.718 453.601C932.409 453.653 933.1 453.704 933.79 453.756'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M841.5 428C822.251 426.858 805.265 421.84 789.5 411.639C804.771 406.307 831.615 414.565 841.5 428'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M820.123 387C832.806 396.914 841.484 409.444 845.5 425.018C845.005 425.345 844.511 425.673 844.015 426C835.51 413.33 827.005 400.662 818.5 387.992C819.041 387.662 819.581 387.332 820.123 387'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10742'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M316.479 126.709C319.161 122.016 321.841 117.323 324.842 112.072C297.164 110.631 271.656 101.08 244.5 93.5248C268.081 74.169 293.477 61.65 323.89 59.5312C322.273 55.1115 320.763 50.9855 318.938 46C325.231 47.6258 328.514 51.4489 330.838 55.9005C332.484 59.0576 334.563 59.8682 337.917 60.2166C361.443 62.6609 381.014 72.9645 397.5 90.3745C380.887 102.398 362.794 109.169 342.9 111.356C341.953 111.46 340.991 111.621 340.051 111.551C333.089 111.031 327.801 112.77 324.939 120.084C323.737 123.16 320.342 125.387 317.943 128C317.455 127.57 316.967 127.139 316.479 126.709Z'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M196.5 123C206.71 106.466 226.986 94.7865 240.5 97.3543C233.091 107.732 211.525 120.413 196.5 123'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M203.018 82.7405C217.284 80.2449 232.355 84.072 241.5 94C228.5 90.8947 215.5 87.7894 202.5 84.6841C202.672 84.0366 202.846 83.3879 203.018 82.7405'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10765'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M309.878 675.984C313.267 673.995 316.655 672.007 320.503 669.75C301.408 653.354 291.76 632.169 287.5 606C310.279 615.293 331.743 624.048 353.041 632.735C353.746 629.773 354.778 625.434 355.811 621.096C356.451 621.148 357.092 621.201 357.732 621.253C357.506 624.974 357.9 628.874 356.882 632.364C355.84 635.94 356.743 637.747 359.44 639.966C373.21 651.292 382.324 665.583 386.5 683.568C375.418 686.487 364.441 686.84 353.695 684.291C345.653 682.383 338.048 678.695 330.145 676.114C327.93 675.391 325.309 675.445 322.948 675.736C318.756 676.254 314.621 677.226 310.462 678.01C310.267 677.335 310.073 676.659 309.878 675.984'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M286.488 602C274.477 594.993 267.94 577.115 271.442 562C279.281 567.765 286.843 587.62 286.488 602'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M282.701 606C269.694 605.683 258.613 600.889 249.5 591.511C249.711 591.007 249.92 590.504 250.131 590C261.253 594.698 272.377 599.396 283.5 604.095C283.233 604.73 282.967 605.365 282.701 606'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10760'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M808.5 349.284C788.292 354.829 768.897 354.398 749.587 348.835C746.402 347.918 744.193 348.002 741.518 350.508C738.613 353.228 734.716 354.882 731.251 357C730.879 356.475 730.508 355.951 730.137 355.427C733.468 352.517 736.799 349.607 739.381 347.353C718.709 335.245 697.605 322.884 676.5 310.524C676.658 309.927 676.818 309.33 676.975 308.733C701.763 300.337 726.962 297.838 753.163 304.639C752.943 300.805 752.74 297.299 752.538 293.793C753.093 293.529 753.651 293.264 754.206 293C756.098 296.182 758.766 299.157 759.676 302.599C760.703 306.481 762.851 308.104 766.172 309.586C784.551 317.792 798.531 330.787 808.5 349.284'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M671.5 310.839C656.926 317.179 642.16 319.959 626.5 318.706C630.811 311.348 658.83 303.725 671.5 310.839'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M672.707 308C662.305 302.277 651.901 296.554 641.5 290.831C641.849 290.221 642.198 289.61 642.549 289C654.923 291.258 665.27 297.079 673.5 306.618C673.236 307.079 672.972 307.539 672.707 308'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10769'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M503.509 752.702C502.99 748.336 502.588 744.951 502.186 741.565C502.81 741.377 503.435 741.188 504.058 741C505.336 745.002 506.612 749.006 508.104 753.686C523.704 757.371 538.369 764.366 549.5 778.833C547.032 780.181 544.838 781.499 542.546 782.609C527.899 789.71 512.543 793.073 496.219 791.857C494.091 791.698 491.725 792.977 489.677 794.007C486.044 795.836 482.569 797.984 479.027 800C478.684 799.566 478.341 799.132 477.999 798.699C480.255 796.122 482.509 793.545 484.38 791.411C475.365 786.648 465.494 782.697 457.112 776.649C448.794 770.648 441.976 762.535 434.5 755.348C434.861 754.467 435.222 753.585 435.583 752.702H503.509Z'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M432.5 749.988C419.309 750.493 404.917 734.391 404.5 723C416.981 728.698 425.683 737.834 432.5 749.988'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M395.5 753H430.5C418.935 757.872 407.302 758.195 395.601 754.505C395.568 754.003 395.533 753.501 395.5 753'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10751'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M736.5 810.469C755.75 796.189 774.026 782.63 792.372 769.02C790.651 767.07 788.187 764.277 785.722 761.484C786.123 760.989 786.527 760.494 786.928 760C790.322 762.592 793.715 765.185 797.652 768.194C812.542 762.138 828.532 759.173 845.5 764.468C845.302 765.445 845.302 766.396 844.927 767.159C837.157 782.962 826.363 796.12 811.323 805.382C808.238 807.281 806.254 809.333 805.251 813.008C804.293 816.521 802.064 819.683 800.397 823C799.859 822.844 799.323 822.69 798.786 822.534C799.224 819.124 799.662 815.713 800.201 811.516C779.341 819.183 758.666 818.972 736.5 810.469'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M695.5 802.929C709.39 800.62 721.661 802.655 733.5 808.596C724.998 816.249 706.444 813.656 695.5 802.929'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M705.5 832C714.834 825.334 724.167 818.667 733.5 812C729.528 821.917 715.635 831.84 705.5 832'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10754'>
			(
			<animated.g key='Fish_17'>
				<mask
					id='mask0_1_20'
					style={{ maskType: 'alpha' }}
					maskUnits='userSpaceOnUse'
					x='991'
					y='518'
					width='58'
					height='122'
				>
					<path id='Clip 16' fillRule='evenodd' clipRule='evenodd' d='M991.5 518H1048.5V640H991.5V518Z' fill='white' />
				</mask>
				(
				<animated.g mask='url(#mask0_1_20)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M1001.83 587.119C1001.14 564.166 1000.45 541.369 999.76 518.571C1000.37 518.381 1000.99 518.19 1001.6 518C1019.59 533.054 1032.78 551.479 1039.59 574.702C1042.33 572.404 1044.75 570.374 1047.17 568.343C1047.61 568.583 1048.06 568.823 1048.5 569.063C1047.15 572.13 1046.36 575.672 1044.3 578.146C1041.67 581.3 1041.53 584.213 1041.96 588.041C1043.95 606.1 1040.94 623.289 1032.05 640C1021.23 630.289 1013.97 618.901 1008.86 606.013C1008.3 604.595 1007.59 603.198 1007.28 601.722C1005.94 595.394 1004.14 589.693 996.18 589.013C994.55 588.873 993.056 587.129 991.5 586.124C991.651 585.652 991.8 585.178 991.951 584.706C995.552 585.585 999.152 586.466 1001.83 587.119'
						fill='black'
					/>
				</animated.g>
				),
			</animated.g>
			),
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M970.5 483C984.337 489.205 994.355 498.672 997.5 514C985.478 506.306 976.169 496.243 970.5 483'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M999.5 514V479C1004.29 491.003 1004.7 502.399 1001.16 513.96C1000.6 513.974 1000.05 513.986 999.5 514'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10744'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M518.252 118.335C520.804 115.857 523.356 113.379 525.373 111.421C508.774 101.314 491.731 90.9359 473.5 79.8365C494.883 70.814 515.154 68.2093 536.65 73.153C536.475 69.7273 536.316 66.6155 536.159 63.5048L537.333 63C538.691 65.101 540.906 67.0755 541.238 69.3305C542.037 74.7491 545.676 76.5718 549.906 78.6785C563.848 85.6266 573.862 96.5891 581.5 111.833C573.943 113.147 566.991 115.208 560 115.35C551.913 115.513 543.721 114.404 535.717 113.012C531.853 112.339 529.089 111.957 526.297 115.354C524.624 117.39 521.823 118.483 519.528 120C519.103 119.445 518.677 118.89 518.252 118.335'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M470.5 80.0079C458.741 86.3773 447.138 89.608 434.5 88.9053C439.93 79.9041 458.801 74.9902 470.5 80.0079'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M470.732 78C462.321 73.0816 453.911 68.1631 445.5 63.2447C445.745 62.8302 445.988 62.4145 446.233 62C456.542 63.5844 464.889 68.5743 471.5 76.5855C471.243 77.057 470.988 77.5285 470.732 78'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10757'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M486.5 264.768C507.893 257.209 527.825 255.747 548.483 261.473V252.486C548.832 252.324 549.183 252.161 549.534 252C550.857 254.154 552.909 256.169 553.347 258.49C554.201 263.012 556.984 264.943 560.761 266.863C574.71 273.953 586.173 286.133 592.5 300.727C584.033 301.469 576.036 302.892 568.09 302.652C560.944 302.436 553.771 300.733 546.776 299.01C543.44 298.187 541.268 298.267 538.779 300.807C536.965 302.657 534.257 303.634 531.948 305C531.647 304.544 531.346 304.087 531.044 303.632C533.51 301.364 535.976 299.095 537.738 297.475C521.224 286.933 504.471 276.239 486.5 264.768'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M448.5 271.306C459.019 263.715 470.322 260.497 484.5 265.193C472.193 270.92 460.738 273.299 448.5 271.306'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M483.707 263C475.691 257.912 467.675 252.822 458.5 247C468.191 247.072 478.34 253.146 484.5 261.615C484.236 262.077 483.972 262.538 483.707 263'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10743'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M417.769 150.803C399.614 146.307 381.412 141.802 361.5 136.871C379.137 123.288 397.069 115.313 418.28 114.015C417.371 111.162 416.513 108.47 415.655 105.777C415.966 105.518 416.276 105.259 416.586 105C418.354 106.445 420.853 107.547 421.745 109.405C423.884 113.859 427.595 114.534 431.826 115.193C446.622 117.493 458.972 124.351 469.5 135.497C456.981 144.097 443.454 148.689 428.724 149.266C424.022 149.45 420.952 150.43 418.921 154.794C418.03 156.71 415.947 158.083 413.243 159C414.85 156.088 416.458 153.177 417.769 150.803'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M358.5 138.04C351.061 146.454 337.875 153.81 328.5 155C332.017 145.843 346.733 137.342 358.5 138.04'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M332.774 128.267C342.666 127.227 351.759 129.108 359.5 136C350.5 133.962 341.5 131.923 332.5 129.885C332.591 129.346 332.682 128.806 332.774 128.267'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10774'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M788.98 456C808.151 461.508 824.584 471.463 837.837 487.045C839.154 484.469 840.334 482.16 841.514 479.852C841.916 479.866 842.318 479.881 842.722 479.896C842.869 481.803 843.641 483.937 843.053 485.58C841 491.302 843.665 495.601 846.213 500.332C852.94 512.818 855.649 527.373 854.056 541C850.323 539.368 846.394 538.417 843.403 536.194C835.375 530.224 827.513 523.977 820.085 517.28C817.178 514.661 815.184 512.033 810.692 513.346C808.733 513.919 806.346 513.026 804.043 511.441C806.991 510.906 809.941 510.37 812.505 509.905C804.237 492.424 795.869 474.732 787.5 457.039C787.994 456.693 788.486 456.346 788.98 456'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M783.5 454C771.365 451.613 760.906 446.696 751.5 438.307C762.959 436.357 778.471 443.94 783.5 454'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M774.788 426C781.883 433.392 786.029 442.222 787.5 452.36C787.072 452.574 786.643 452.788 786.215 453C781.977 444.281 777.739 435.562 773.5 426.843C773.929 426.562 774.359 426.281 774.788 426'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10746'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M669.5 433.218C687.054 431.892 703.516 436.556 726.921 448.924C727.486 446.252 728.036 443.648 728.586 441.045C728.936 441.017 729.284 440.988 729.634 440.96C730.341 442.824 731.82 444.779 731.616 446.538C730.895 452.767 734.978 455.991 738.611 459.841C748.176 469.975 754.432 481.916 757.5 497C751.347 495.837 745.622 495.548 740.526 493.607C732.446 490.53 724.604 486.676 717.036 482.473C713.917 480.742 711.717 479.846 708.415 481.696C706.437 482.805 703.826 482.772 701.501 483.252C701.346 482.815 701.193 482.379 701.038 481.943C703.813 480.585 706.586 479.227 708.795 478.147C696.128 463.664 683.257 448.948 669.5 433.218'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M631.5 425.716C643.828 422.712 655.644 423.056 667.5 431.611C654.02 432.826 642.47 431.286 631.5 425.716'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M648.644 407C657.143 412.305 663.565 419.513 667.5 428.999C667.143 429.333 666.786 429.666 666.429 430C660.118 422.686 653.808 415.372 647.5 408.057C647.881 407.705 648.262 407.352 648.644 407'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10776'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M78.8192 284C89.2846 301.403 98.9177 317.419 108.473 333.309C109.984 331.9 112.184 329.849 114.388 327.796C114.758 328.018 115.129 328.241 115.5 328.463C114.722 329.954 114.326 332.023 113.095 332.837C108.131 336.124 109.405 340.197 110.573 344.797C113.691 357.085 113.617 369.36 109.252 382C96.7987 375.009 87.1922 365.701 80.6764 353.442C78.3062 348.981 76.1907 344.844 70.7021 343.523C69.0385 343.122 67.692 341.411 66.5 339.096C68.9774 339.401 71.4549 339.707 74.6678 340.102C69.834 321.62 71.1863 303.559 78.8192 284'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M86.2426 249C87.3112 261.092 85.0117 271.675 80.1083 282C74.9434 273.654 77.6859 258.381 86.2426 249'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M76.2557 283C69.0995 276.793 64.426 269.109 62.5 259.79C62.9319 259.527 63.3639 259.264 63.7958 259C68.3639 266.698 72.9319 274.394 77.5 282.091C77.0852 282.394 76.6693 282.697 76.2557 283'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10748'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M254.853 710.058C255.107 708.201 255.453 705.648 255.802 703.096L257.288 703.071C257.52 705.969 257.752 708.867 258.038 712.41C268.912 717.114 278.728 723.962 284.5 736.115C272.535 740.55 260.648 742.43 248.372 740.077C243.561 739.154 239.138 738.491 234.736 741.349C233.433 742.195 231.557 742.172 229.38 741.536C231.212 740.104 233.045 738.672 235.464 736.782C220.979 729.871 210.968 719.06 204.5 703C221.962 705.448 238.374 707.748 254.853 710.058'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M204.5 701C194.064 697.821 188.323 689.421 188.504 678C196.884 683.808 201.505 691.446 204.5 701'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M201.283 703.327C192.966 705.015 185.082 703.439 177.5 699.584C177.572 699.056 177.642 698.529 177.713 698C185.643 699.232 193.571 700.463 201.5 701.695C201.428 702.239 201.354 702.784 201.283 703.327'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10771'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M663.435 807.938C664.037 805.647 664.639 803.357 665.356 800.63C648.866 801.451 634.706 796.076 620.5 785.786C635.937 779.931 650.27 774.493 664.801 768.981C663.889 767.287 662.616 764.925 661.344 762.563C661.576 762.375 661.81 762.188 662.043 762C662.73 762.478 663.791 762.807 664.045 763.455C666.701 770.194 672.32 769.538 678.003 769.571C687.476 769.625 696.193 772.488 704.5 777.963C697.546 787.494 688.81 794.126 677.993 797.805C673.66 799.279 669.299 800.13 667.61 805.222C667.154 806.6 666 807.747 665.166 809C664.589 808.647 664.012 808.292 663.435 807.938'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M619.5 784.564C609.664 786.558 599.698 781.602 593.5 772C603.556 773.272 611.603 777.722 619.5 784.564'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M619.5 789.389C612.482 791.926 605.467 794.463 598.449 797C598.132 796.186 597.817 795.373 597.5 794.558C604.459 792.039 611.42 789.519 618.38 787C618.753 787.796 619.126 788.593 619.5 789.389'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10767'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M118.712 556C107.98 551.554 99.1118 545.331 92.9141 535.924C90.138 531.711 87.617 527.864 82.1621 527.099C80.9714 526.932 79.9053 525.874 77.5 524.487H85.4067C84.9553 516.678 83.6942 508.982 84.31 501.439C84.9134 494.039 87.4253 486.795 89.0992 479.482C89.749 479.322 90.3988 479.16 91.0486 479C99.9873 491.276 108.925 503.554 117.995 516.012C119.397 514.793 121.528 512.94 124.5 510.356C124.11 512.088 124.17 512.813 123.86 513.046C117.773 517.652 119.346 523.262 120.89 529.501C123.054 538.239 122.327 547.073 118.712 556'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M97.254 449C98.2698 459.357 96.0961 467.786 91.5426 476C87.5025 468.037 89.4808 458.189 97.254 449'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M75.7375 458C79.9909 464.007 84.2466 470.013 88.5 476.02L87.1751 477C80.7886 472.559 76.5156 466.531 74.5 458.804C74.9121 458.536 75.3254 458.268 75.7375 458'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10755'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M578.324 24.9555C578.58 24.7803 579.782 23.9538 581.043 23.0889C571.768 16.8127 562.647 10.6393 552.5 3.77182C564.7 0.101758 575.521 0.677255 586.532 4.08049C586.802 2.51568 587.013 1.29911 587.238 0C587.751 0.295098 588.14 0.417207 588.386 0.674994C591.124 3.5457 593.787 6.48989 596.575 9.31423C601.53 14.332 606.556 19.2797 612.5 25.1998C603.823 28.2265 597.116 26.7657 590.325 25.6452C586.501 25.0143 582.545 25.1704 578.324 24.9555'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M549.5 5.26188C543.257 5.84125 537.015 6.42063 530.773 7C530.681 5.97219 530.59 4.94438 530.5 3.91657C536.685 3.2781 542.87 2.63847 549.054 2C549.203 3.08691 549.351 4.17497 549.5 5.26188'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10761'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M888.5 197C901.019 200.072 910.289 205.879 918.134 214.25C918.974 213.113 919.707 212.122 920.505 211.041C920.902 211.574 921.22 211.822 921.298 212.132C922.293 216.037 922.813 220.134 924.319 223.825C927.138 230.739 929.173 237.66 928.292 247C922.197 242.978 916.929 239.819 912.028 236.166C908.328 233.408 906.173 228.017 899.938 229.305C901.253 228.848 902.569 228.39 903.686 228.002C898.822 218.073 893.944 208.115 888.5 197'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M867.5 189.509C875.774 187.87 881.216 190.144 885.5 197C879.5 194.503 873.501 192.006 867.5 189.509'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10747'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M422.5 582.945C410.694 583.429 400.235 580.741 390.868 574.577C386.804 571.902 383.101 569.541 378.004 570.829C376.864 571.117 375.509 570.56 373.904 569.348C375.975 568.447 378.045 567.545 380.559 566.451C369.962 554.174 365.325 539.699 364.5 522C378.72 530.565 391.955 538.536 405.066 546.431C405.748 544.696 406.694 542.295 407.639 539.892C407.933 539.927 408.227 539.961 408.522 539.996C408.626 540.779 409.079 541.743 408.782 542.319C405.749 548.19 408.716 552.114 412.352 556.566C418.417 563.992 421.579 572.829 422.5 582.945'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M364.398 519C356.888 512.663 354.575 502.031 358.143 491C363.393 499.764 364.941 508.713 364.398 519'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M361.5 520C352.955 519.66 346.618 515.666 342.5 508C348.833 512 355.167 516.001 361.5 520'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10778'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.5 135.361C16.829 135.493 17.9505 135.942 19.6453 136.62C22.093 126.489 27.6521 118.406 36.7171 111C37.8861 121.948 38.9183 131.623 39.9901 141.659C41.1071 141.54 42.656 141.376 44.5 141.18C43.9946 141.865 43.7402 142.588 43.3728 142.651C39.6747 143.289 38.7668 145.9 37.53 149.123C35.2858 154.965 31.9822 160.396 29.1218 166C28.2128 165.994 27.3061 165.99 26.3971 165.985C24.1914 160.425 21.7301 154.948 19.859 149.275C18.3609 144.732 17.5797 139.952 16.5 135.361'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M49.5 96.3617C45.9087 100.574 42.3163 104.787 38.7261 109C38.3171 108.632 37.908 108.263 37.5 107.895C38.3104 101.207 42.7728 97.6891 48.1923 95C48.6289 95.4539 49.0634 95.9078 49.5 96.3617'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10770'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M609.5 827.688C600.853 835.611 591.503 840.871 580.787 843.399C575.974 844.534 571.243 845.232 568.205 849.798C567.482 850.883 565.889 851.39 563.402 853C565.021 849.722 565.973 847.796 567.207 845.297C551.873 844.726 538.856 839.266 526.5 828.162C542.991 824.006 558.138 820.188 573.52 816.31C573.051 814.777 572.362 812.53 571.666 810.257C572.269 810.131 572.876 809.966 572.89 810.006C575.343 817.108 581.212 817.469 587.499 818.093C595.486 818.885 602.851 821.848 609.5 827.688'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M501.5 813C511.132 815.07 518.246 819.62 524.5 826.693C515.496 828.31 507.353 823.506 501.5 813'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M501.5 834.35C508.973 832.567 516.447 830.783 523.92 829C524.113 829.745 524.306 830.492 524.5 831.236C517.036 833.158 509.573 835.079 502.11 837C501.907 836.116 501.704 835.234 501.5 834.35'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10753'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M858.5 846.122C853.592 851.749 849.668 856.564 845.394 861.04C842.276 864.304 838.694 867.124 835.478 870C835.437 869.794 835.173 868.464 834.859 866.883C824.542 869.516 814.775 868.658 804.5 864.085C820.341 852.246 834.654 838.691 858.5 846.122'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M784.5 859C790.139 860.201 795.779 861.402 802.5 862.834C795.791 866.677 789.53 865.411 784.5 859'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10749'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M79.4933 656C88.7571 658.969 98.022 661.939 107.723 665.048C108.067 664.133 108.598 662.721 108.618 662.664C110.794 665.5 113.178 668.551 115.502 671.646C118.857 676.116 122.17 680.619 125.5 685.106L124.512 686.885C118.483 686.885 112.432 687.202 106.43 686.784C101.693 686.455 97.0174 685.223 91.8094 684.302C92.5529 683.896 93.8492 683.187 93.8447 683.19C88.2531 674.582 82.876 666.305 77.5 658.028C78.164 657.352 78.8292 656.676 79.4933 656'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M74.254 654L67.5 638.259C68.4009 637.84 69.303 637.42 70.2039 637C72.6355 642.267 75.0683 647.533 77.5 652.8C76.418 653.199 75.336 653.6 74.254 654'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10759'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M798.5 269C787.014 268.697 777.298 265.121 768.448 259.173C764.726 256.67 761.482 253.934 756.797 257.07C755.871 257.688 754.266 257.282 752.715 256.486C755.025 255.417 757.337 254.348 759.103 253.532C749.943 241.519 740.705 229.403 730.5 216.018C748.52 215.686 763.458 219.944 777.233 229.451C778.021 227.151 778.72 225.109 779.674 222.321C780.426 223.496 781.132 224.087 781.066 224.572C780.059 232.047 784.854 236.734 788.843 242.04C794.595 249.693 797.465 258.611 798.5 269'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M698.5 210.552C709.734 207.793 718.939 208.281 728.5 215.56C717.578 216.756 708.521 215.649 698.5 210.552'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M716.587 196C722.743 200.268 727.392 205.725 728.5 214L715.5 197.016C715.864 196.678 716.225 196.338 716.587 196'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10750'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M244.536 870C244.74 869.622 245.371 868.448 246.149 867.005C236.307 863.264 228.515 857.373 222.5 847.603H253.226C253.149 846.008 253.079 844.58 253.002 843C253.524 843.129 253.985 843.151 254.007 843.263C254.835 847.348 257.737 848.816 261.31 850.556C266.72 853.189 271.47 857.177 276.5 860.589L275.939 863.024C270.414 864.682 264.958 866.641 259.345 867.911C254.46 869.016 249.399 869.344 244.536 870'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M220.244 845C213.84 843.421 210.627 838.847 208.5 833.256C208.95 832.838 209.399 832.419 209.85 832C213.734 835.945 217.616 839.888 221.5 843.831C221.08 844.222 220.662 844.611 220.244 845'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10763'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M510.942 559.755C512.048 559.091 513.154 558.427 514.645 557.532C506.05 550.791 500.499 542.583 497.5 531C507.966 534.27 517.512 537.252 527.477 540.365C527.725 539.448 528.119 538.002 528.077 538.155C530.063 540.641 532.448 543.562 534.759 546.54C538.313 551.122 541.817 555.743 545.5 560.556C533.163 567.192 522.51 558.019 510.942 559.755'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M496.01 529C490.323 525.399 488.373 520.046 488.506 513.717C489.021 513.478 489.534 513.239 490.05 513L497.5 528.309C497.004 528.54 496.508 528.77 496.01 529'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10752'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M734.005 891.003C733.493 890.095 732.788 888.843 731.751 887C732.796 887.304 733.462 887.3 733.616 887.572C735.471 890.857 738.369 890.756 741.809 890.942C748.124 891.283 754.379 892.694 760.658 893.658C760.939 894.597 761.22 895.537 761.5 896.476C756.611 900.36 751.849 904.412 746.79 908.07C743.176 910.683 739.163 912.767 735.472 915V911.991C724.706 912.389 715.093 910.211 705.5 903.651C715.539 899.196 724.679 895.14 734.005 891.003'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M703.5 901.859C697.308 904.411 692.892 902.777 688.5 896C693.5 897.952 698.5 899.906 703.5 901.859'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10777'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M89.5 214.008C90.3105 214.229 92.041 214.702 94.2303 215.3C92.5114 200.6 94.9889 187.14 102.505 173C108.72 187.486 114.445 200.829 120.235 214.324C121.471 213.572 123.306 212.455 125.285 211.25C125.39 211.999 125.587 212.534 125.458 212.627C120.351 216.335 120.285 221.23 120.953 227.017C121.926 235.421 120.481 243.712 116.324 252C108.474 245.829 103.09 238.43 98.8546 229.954C96.0865 224.412 92.5955 219.229 89.5 214.008'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M112.5 148.479C110.24 155.91 107.979 163.342 105.346 172C101.295 163.993 104.243 153.713 110.962 148L112.5 148.479Z'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M99.2792 171C96.6865 164.953 94.0927 158.904 91.5 152.857C92.2087 152.571 92.9174 152.286 93.6261 152C96.2503 158.055 98.8746 164.109 101.5 170.164C100.761 170.443 100.019 170.721 99.2792 171'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10779'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M165.03 413C155.489 405.889 149.889 398.617 145.391 390.279C142.485 384.896 138.737 379.953 135.5 375.016C136.403 375.226 138.158 375.637 140.5 376.183C138.494 361.545 140.27 347.911 147.652 334C154.253 348.13 160.415 361.319 166.597 374.551C167.933 373.657 169.716 372.463 171.5 371.268C164.176 376.931 168.334 384.388 167.85 391.046C167.351 397.937 166.121 404.775 165.03 413'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M156.5 308.654C154.366 316.436 152.233 324.218 150.098 332C149.47 331.814 148.843 331.627 148.215 331.441C146.018 322.44 149.116 314.923 154.328 308C155.052 308.218 155.776 308.436 156.5 308.654'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M137.647 313C140.264 319.036 142.883 325.072 145.5 331.109C144.852 331.406 144.205 331.703 143.558 332C140.872 325.907 138.185 319.813 135.5 313.719L137.647 313Z'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10773'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M1016.59 421C1023.11 427.977 1029.64 434.953 1036.57 442.371C1036.41 442.479 1037.33 441.896 1037.5 441.789V472.033C1036.71 472.356 1035.92 472.678 1035.13 473C1029.12 465.757 1023.1 458.514 1017.26 451.48C1017.24 451.485 1018.47 451.278 1019.47 451.111C1017.79 441.39 1016.14 431.862 1014.5 422.335C1015.2 421.889 1015.9 421.445 1016.59 421'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M1011.45 420L999.5 409.347C999.867 408.898 1000.23 408.449 1000.6 408C1005.8 410.066 1010.4 412.856 1012.5 418.71C1012.15 419.141 1011.8 419.57 1011.45 420'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10745'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M710.537 140C718.791 142.304 727.044 144.607 735.61 146.998C735.516 147.155 735.982 146.381 736.442 145.616C741.159 153.418 745.829 161.142 750.5 168.866C749.936 169.577 749.373 170.289 748.81 171C740.928 168.277 733.045 165.555 725.281 162.874C725.167 162.994 725.899 162.224 726.55 161.539C720.888 155.067 715.194 148.559 709.5 142.052L710.537 140Z'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M692.922 137C697.449 137.785 701.976 138.57 706.5 139.356C706.354 140.237 706.206 141.119 706.06 142L692.5 139.506C692.641 138.671 692.782 137.835 692.922 137'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10764'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M541.5 455C524.794 454.929 513.24 444.959 500.5 426.354C506.518 425.202 513.729 426.875 522.607 431.18C523.88 431.796 525.622 431.425 527.529 431.533C531.651 438.455 536.226 446.142 541.5 455'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M483.764 421C488.343 421.778 492.921 422.557 497.5 423.334C497.372 424.224 497.244 425.112 497.118 426C492.579 425.27 488.04 424.541 483.5 423.811C483.589 422.874 483.676 421.937 483.764 421'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10756'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M410.5 256.87C403.845 261.096 397.501 265.949 390.438 269.346C384.994 271.964 379.122 273.321 378.227 281C377.8 280.683 377.374 280.365 376.948 280.049C377.373 278.026 377.797 276.005 378.104 274.55H338.5C347.442 263.494 358.075 255.333 371.833 250.624C370.847 248.884 370 247.388 369.781 247C377.86 247.774 386.413 248.21 394.821 249.543C399.949 250.356 404.853 252.55 409.855 254.123C410.07 255.038 410.285 255.953 410.5 256.87'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M318.5 292.439C322.25 284.715 327.596 278.684 336.098 276C336.565 276.497 337.033 276.994 337.5 277.49C331.655 282.994 325.811 288.497 319.966 294C319.478 293.479 318.988 292.96 318.5 292.439'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M335.5 275H318.586C318.557 274.565 318.529 274.129 318.5 273.694C324.102 273.463 329.704 273.231 335.307 273L335.5 275Z'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10775'>
			(
			<animated.g key='Fish_84'>
				<mask
					id='mask1_1_20'
					style={{ maskType: 'alpha' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='400'
					width='21'
					height='39'
				>
					<path id='Clip 83' fillRule='evenodd' clipRule='evenodd' d='M0.5 400H20.5V439H0.5V400Z' fill='white' />
				</mask>
				(
				<animated.g mask='url(#mask1_1_20)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0.499512 425.139C0.743557 423.13 1.07573 421.595 1.08929 420.057C1.1503 413.541 1.11528 407.024 1.11528 400.506C1.77849 400.337 2.44284 400.169 3.10606 400C7.87512 406.006 12.6464 412.012 17.4889 418.11C18.038 417.698 18.7826 417.139 19.543 416.568C19.6673 416.872 19.9181 417.183 19.8898 417.466C19.674 419.697 19.1046 421.936 19.2131 424.144C19.4503 428.96 20.0243 433.761 20.5 439C10.1054 437.99 6.97463 428.359 0.499512 425.139'
						fill='black'
					/>
				</animated.g>
				),
			</animated.g>
			),
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5.5 385.461C4.70885 389.64 3.91769 393.821 3.12654 398C2.25061 397.848 1.37592 397.696 0.5 397.544C1.2973 393.363 2.09582 389.182 2.89435 385C3.7629 385.153 4.63145 385.308 5.5 385.461'
				fill='black'
			/>
		</animated.g>,
		<animated.g key='Fish_10762'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M359.5 401.82C359.857 401.789 361.052 401.684 362.701 401.541C360.688 391.379 361.859 381.57 366.982 371C372.761 380.03 378.113 388.395 383.704 397.132C384.608 396.547 385.908 395.706 387.5 394.675C387.43 395.55 387.528 396.003 387.362 396.137C384.33 398.588 384.5 401.481 384.855 405.173C385.459 411.415 384.707 417.785 384.523 424.101C383.719 424.4 382.916 424.701 382.113 425C377.756 421.162 373.172 417.544 369.114 413.418C365.587 409.833 362.654 405.674 359.5 401.82'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M373.5 351.451C371.996 356.959 370.489 362.465 368.703 369C364.99 362.665 365.968 358.25 371.66 351C372.273 351.151 372.886 351.302 373.5 351.451'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M358.994 357C361.163 360.684 363.332 364.366 365.5 368.05C364.982 368.366 364.462 368.683 363.944 369C361.797 365.302 359.647 361.605 357.5 357.908C357.999 357.605 358.496 357.303 358.994 357'
				fill='black'
			/>
		</animated.g>,
	];
	const [springs] = useSprings(fishGroups.length, () => {
		return {
			config: {
				duration: 35000,
				progress: Math.random(),
			},
			from: { opacity: 1, transform: `rotate3d(0,0,1,0deg)`, transformOrigin: '50% 50%' },
			loop: true,
			to: { opacity: 0, transform: `rotate3d(0,0,1,-360deg)`, transformOrigin: '50% 50%' },
		};
	});
	return (
		<SvgIcon fill='none' height={917} width={1049} {...props}>
			<animated.g key='Fish' opacity='0.526595'>
				{springs.map((springProps, i) => {
					const { opacity, ...restSpringProps } = springProps;
					return (
						<animated.g
							key={i}
							style={{
								...restSpringProps,
								opacity: opacity.to({
									output: opacity.goal < 1 ? [1, 0.5, 0] : [0, 0.5, 1],
									range: opacity.goal < 1 ? [0, 0.8, 1] : [0, 0.25, 1],
								}),
							}}
						>
							{fishGroups[i]}
						</animated.g>
					);
				})}
			</animated.g>
		</SvgIcon>
	);
};

export const Daisy: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<SvgIcon fill='none' height={1043} width={669} {...props}>
			<path
				d='M89.735 722s-3.05 25.335-13.213 41.474c-10.162 16.14-45.713 101.19 39.579 150.397 85.292 49.208 225.204 82.276 253.305 91.579 28.101 9.3 134.416 75.67 139.154 6.26 0 0 36.739 2.02 38.776-14.193 2.037-16.209-11.175-21.283-33.014-20.772-21.838.511-37.076-15.199-37.076-15.199s87.865-2.531 97.516-19.251c9.65-16.72-8.638-28.377-17.264-28.377 0 0-56.889 2.543-74.164-3.541 0 0 54.352-18.775 72.174-27.867 17.822-9.091 10.116-33.172 10.116-33.172s-9.441-9.057-27.531-6.967'
				fill='url(#daisy__a)'
			/>
			<path
				d='m318.5 632.109-4.124 15.798-.151 9.854L186.258 761l-50.99-9.867c-30.275-11.085-45.61-29.204-45.61-29.204-13.186-41.451 90.617-170.749 90.617-170.749L238.897 521 318.5 632.109Z'
				fill='url(#daisy__b)'
			/>
			<path
				d='M251.94 479.676s.895 12.607-57.805 10.851c0 0-12.24 5.35-6.056 33.728 0 0 3.998 16.282-7.579 26.924l49.982-17.795S293.704 601.387 314.499 643l95.001-23.458L294.576 473s-17.436 31.053-42.636 6.676Z'
				fill='url(#daisy__c)'
			/>
			<path
				d='m516.685 504.261 33.815 78.013-76.219 62.226-85.404 4.5-42.789-79.785-39.588-57.492V472l177.605 13.42 32.58 18.841Z'
				fill='url(#daisy__d)'
			/>
			<path
				d='M653.014 641s70.801 175.846-90.37 235.684c-161.171 59.838-16.396-117.807-16.396-117.807l31.247-112.351L653.014 641Z'
				fill='url(#daisy__e)'
			/>
			<path
				d='M230.5 491s1.444 1.041 4 3'
				stroke='#fff'
				strokeWidth='2.66'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M243.5 502c22.412 20.822 69.222 67.84 96 120'
				stroke='#fff'
				strokeWidth='2.66'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeDasharray='9.87'
			/>
			<path
				d='M343.5 627a237.709 237.709 0 0 1 2 5m-91-149s1.433 1.048 4 3'
				stroke='#fff'
				strokeWidth='2.66'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M267.5 495c22.4 20.822 69.21 67.84 96 120'
				stroke='#fff'
				strokeWidth='2.66'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeDasharray='9.87'
			/>
			<path
				d='M367.5 619c.689 1.659 1.35 3.329 2 5'
				stroke='#fff'
				strokeWidth='2.66'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M558.111 466s38.85 43.402 42.389 87.363c0 0-59.357 18.674-63.856 21.637 0 0-10.999-43.798-11.566-43.205l-.578.581s26.301-12.527 33.611-66.376Z'
				fill='url(#daisy__f)'
			/>
			<path
				d='M598.5 542c44.313 11.332 67.749 87.02 66.982 91.264-.768 4.244-53.141 49.736-53.141 49.736'
				fill='url(#daisy__g)'
			/>
			<path
				d='M554.5 499s25.581 30.86 23.923 57M543.5 512s19.02 22.878 14.225 46'
				stroke='#fff'
				strokeWidth='2.66'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeDasharray='9.61'
			/>
			<path
				d='M599.68 554h6.664s2.206 31.864 10.565 37.955c0 0 14.523 33.949 5.804 67.409-5.212 20.078-5.178 102.488-26.306 140.688 0 0-18.575 24.457-31.763 25.924-13.188 1.468-250.144-65.044-250.144-182.73'
				fill='url(#daisy__h)'
			/>
			<path
				d='M337.5 658s72.731-22.194 87.78-33.054c15.049-10.86 62.291-27.502 76.816-29.006 14.525-1.503 91.12-20.887 108.404-19.904'
				stroke='#fff'
				strokeWidth='2.66'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeDasharray='9.61'
			/>
			<ellipse cx='596.5' cy='587.5' rx='11' ry='17.5' fill='#FAF9DF' />
			<circle cx='366.5' cy='662' r='18' fill='#FAF9DF' />
			<path
				d='M63.435 642.886s-17.672 3.04-38.885-22.276c0 0-29.279 0-23.226-18.215 6.052-18.215 53.026-74.368 53.026-74.368s21.71-17.716 23.227 7.599c0 0 41.407 3.539 42.923 31.894l-57.065 75.366Z'
				fill='url(#daisy__i)'
			/>
			<path
				d='M347.092 662.607c.026-.349.17-.68.408-.938L323 644.923s-44.333-22.872-83.999-7.759c-24.045 35.507-127.073 27.794-147.501 25.837a187.638 187.638 0 0 1 32.211 33.909l56.42 25.478v32.623A477.572 477.572 0 0 0 247.576 815c.093-.127.116-.29.256-.394.934-.706 97.498-66.868 99.26-151.999Z'
				fill='url(#daisy__j)'
			/>
			<path
				d='M239.5 637.303s-47.119-50.615-94.215-54.194L120.728 568 63.5 643.544S75.663 649.355 91.26 662c98.951-41.642 148.24-24.697 148.24-24.697Z'
				fill='url(#daisy__k)'
			/>
			<path
				d='M522.472 783.581a1.472 1.472 0 0 1 .953-1.6C473.683 747.663 392.321 691.832 350.217 663c-1.233 45.103-28.248 84.454-50.812 109.563a305.93 305.93 0 0 1-48.905 43.933c27.004 19.194 58.228 35.697 87.092 36.637 0 0 39.524-7.028 42.605-15.379 0 0 31.956-3.792 49.463 28.844 0 0 26.876 3.038 40.826-7.585 0 0 17.146-4.639 36.374-8.745-.083-.4-.003-.817.22-1.16.256-.348 21.239-32.392 15.392-65.527Z'
				fill='#FAF9DF'
			/>
			<path
				d='M566.029 812.134c-.824-.776-16.837-11.919-40.293-28.134 5.334 31.358-11.303 60.622-15.236 67a320.361 320.361 0 0 1 32.027-5.389c6.51-.619 13.07.442 19.052 3.083l4.45 1.941s3.309-35.43 0-38.501Z'
				fill='url(#daisy__l)'
			/>
			<path
				d='M239.5 636.475s-49.527-17.277-149 25.217c.502.414.992.794 1.493 1.185 20.406 1.991 123.438 9.93 147.507-26.402Z'
				fill='url(#daisy__m)'
			/>
			<path
				d='M300.316 772.868c22.729-25.223 49.943-64.753 51.184-110.062L348.842 661c-.239.26-.383.592-.41.944-1.768 85.642-98.691 152.202-99.674 152.866-.141.105-.164.268-.258.396.831.606 1.686 1.165 2.529 1.794a307.867 307.867 0 0 0 49.287-44.132Zm225.138 10.633L523.285 782a1.489 1.489 0 0 0-.967 1.618c5.895 33.492-15.326 65.881-15.562 66.21a1.563 1.563 0 0 0-.224 1.172l3.667-.774c3.937-6.33 20.596-35.484 15.255-66.725Z'
				fill='#BE1E2D'
			/>
			<path
				d='M433.5 1003s56.529 20.09 76 10.32'
				stroke='#563217'
				strokeWidth='2.66'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M194.793 490s-11.933 5.382-5.904 33.928c0 0 3.898 16.379-7.389 27.072l29-10.646-.725-36.174L194.793 490Z'
				fill='url(#daisy__n)'
			/>
			<path d='m209.5 505 21 28.665L210.257 541l-.757-36Z' fill='url(#daisy__o)' />
			<path
				d='M219.591 336s-62.936 6.261-57.792 61.911c1.422 15.327 8.31 29.559 18.493 41.045 15.026 17.003 43.783 43.862 85.139 58.676 11.633 3.977 24.429-.952 30.456-11.73l.613-1.071'
				fill='url(#daisy__p)'
			/>
			<path
				d='M212.221 304.815s33.977 193.699 175.033 241.097c0 0 153.385 73.157 176.056-66.969 0 0 13.386-24.188 0-44.038 0 0 36.614-23.967 5.949-198.095 0 0-32.71-166.918-193.334-123.647 0 0-177.078-8.234-163.704 191.652Z'
				fill='url(#daisy__q)'
			/>
			<path
				d='M563.01 435.767s12.352 21.762 0 39.918l-6.076 29.008s-24.797 64.379-87.113 61.192c-55.879-2.861-82.201-16.376-116.519-33.963 0 0-38.871-46.955-4.832-65.507 0 0 63.481-34.359 90.908-53.876a24.594 24.594 0 0 1 27.579-.605c13.376 8.561 32.317 19.262 43.446 19.331 0 0 44.063-4.117 52.607 4.502Z'
				fill='url(#daisy__r)'
			/>
			<path
				d='M560.892 474.51c-5.651-.057-36.523.092-62.161 9.844a7.335 7.335 0 0 1-5.919-.23c-6.883-3.522-30.231-12.528-101.055-22.097a2.888 2.888 0 0 0-2.412.792 2.801 2.801 0 0 0-.82 2.375c1.163 8.811 11.755 31.849 88.776 47.039A90.305 90.305 0 0 0 494.742 514c18.814 0 55.185-4.589 66.731-38.641a.657.657 0 0 0-.089-.559.675.675 0 0 0-.492-.29Z'
				fill='#E69070'
			/>
			<path
				d='M568.928 253.038s-59.882-3.889-67.591 67.516c0 0-16.796 66.113 51.178 79.045 0 0 21.943 4.643 26.985-17.669'
				fill='url(#daisy__s)'
			/>
			<path
				d='M440.149 392.447c11.287-13.386 26.066-43.433-.833-94.934 0 0-40.985-69.474-97.86-19.331 0 0-53.278 40.565 6.153 101.169 0 0 25.731 32.914 72.695 24.172a34.016 34.016 0 0 0 19.845-11.076Z'
				fill='url(#daisy__t)'
			/>
			<path
				d='M367.199 351.963a49.193 49.193 0 0 1-5.88-1.996 56.028 56.028 0 0 1-5.469-2.611 40.217 40.217 0 0 1-5.034-3.283A29.72 29.72 0 0 1 346.5 340a29.874 29.874 0 0 0 4.857 3.249 38.989 38.989 0 0 0 5.304 2.32 52.081 52.081 0 0 0 5.552 1.602c1.843.435 3.713.752 5.598.951a1.954 1.954 0 0 1 1.679 2.12 1.966 1.966 0 0 1-2.067 1.755l-.224-.034Zm4.803-5.012a59.61 59.61 0 0 1-10.501-3.837 54.559 54.559 0 0 1-9.499-5.65 38.276 38.276 0 0 1-7.793-7.732A28.705 28.705 0 0 1 339.5 320a28.245 28.245 0 0 0 5.474 9.124 36.753 36.753 0 0 0 8.134 6.738 51.956 51.956 0 0 0 9.523 4.55 56.814 56.814 0 0 0 10.089 2.702h.129a1.958 1.958 0 0 1 1.625 2.246 1.967 1.967 0 0 1-2.26 1.614l-.212-.023Zm7.032-6a60.455 60.455 0 0 1-10.515-3.837 55.103 55.103 0 0 1-9.501-5.65 38.047 38.047 0 0 1-7.803-7.732A28.7 28.7 0 0 1 346.5 314a28.344 28.344 0 0 0 5.469 9.124 37.046 37.046 0 0 0 8.146 6.726 52.813 52.813 0 0 0 9.536 4.562 57.249 57.249 0 0 0 10.114 2.702h.082a1.958 1.958 0 0 1 1.627 2.246 1.97 1.97 0 0 1-2.263 1.614l-.177-.023Z'
				fill='#231F20'
			/>
			<path
				d='M371.14 337.442a60.072 60.072 0 0 1-7.661-9.103 67.636 67.636 0 0 1-5.866-10.119c-.434-.875-.845-1.75-1.174-2.66-.328-.911-.762-1.786-1.102-2.696-.622-1.833-1.314-3.641-1.772-5.52A64.863 64.863 0 0 1 351.5 296a65.646 65.646 0 0 0 2.992 11.04c.61 1.809 1.443 3.501 2.194 5.264.41.851.868 1.692 1.302 2.532.434.84.88 1.669 1.373 2.474a66.594 66.594 0 0 0 6.488 9.266 58.23 58.23 0 0 0 7.849 7.89l.082.07c.839.683.963 1.913.276 2.748a1.97 1.97 0 0 1-2.763.274l-.153-.116Zm14.478.343a42.637 42.637 0 0 1-5.492-3.502 52.118 52.118 0 0 1-4.918-4.098 46.892 46.892 0 0 1-8.043-9.889 42.414 42.414 0 0 1-2.849-5.697 39.577 39.577 0 0 1-2.62-18.599 40.521 40.521 0 0 0 1.677 12.282 38.233 38.233 0 0 0 2.298 5.709 40.417 40.417 0 0 0 3.149 5.254 44.37 44.37 0 0 0 8.307 8.745 49.893 49.893 0 0 0 4.906 3.502 39.485 39.485 0 0 0 5.182 2.744h.069a1.945 1.945 0 0 1 1.199 1.554c.093.7-.194 1.396-.751 1.82a1.892 1.892 0 0 1-1.93.222l-.184-.047Z'
				fill='#231F20'
			/>
			<path
				d='M383.236 328.625a21.44 21.44 0 0 1-2.432-2.149 30.406 30.406 0 0 1-2.031-2.279 39.824 39.824 0 0 1-3.442-4.886 51.985 51.985 0 0 1-4.791-10.677l-.827-2.772c-.267-.928-.425-1.879-.656-2.807-.463-1.868-.681-3.782-.973-5.662-.292-1.879-.329-3.805-.511-5.696L367.5 286l.584 5.65c.34 1.867.571 3.735.997 5.579.426 1.844.827 3.676 1.459 5.462.292.892.535 1.797.876 2.666l1.033 2.619a50.415 50.415 0 0 0 5.448 9.749 38.039 38.039 0 0 0 3.563 4.229 27.063 27.063 0 0 0 1.995 1.879 18.076 18.076 0 0 0 2.043 1.55h.073c.943.591 1.213 1.808.602 2.719-.611.912-1.872 1.172-2.816.582l-.121-.059Zm6.552-3.009c-2.717-5.577-5.269-11.201-7.621-16.928a188.707 188.707 0 0 1-3.314-8.7A49.444 49.444 0 0 1 376.5 291a49.363 49.363 0 0 0 3.203 8.631c1.271 2.777 2.64 5.52 4.076 8.216a291.343 291.343 0 0 0 9.146 15.833c.553.547.726 1.393.436 2.128-.29.735-.983 1.209-1.745 1.192-.762-.017-1.435-.521-1.695-1.269l-.133-.115Z'
				fill='#231F20'
			/>
			<path
				d='M391.626 325.65c.386-2.946.608-6.019.737-9.046a88.215 88.215 0 0 0-.094-9.127 51.267 51.267 0 0 0-1.262-9.034A25.268 25.268 0 0 0 387.5 290a25.75 25.75 0 0 1 4.395 8.176 52.913 52.913 0 0 1 2.268 9.081c.52 3.072.879 6.168 1.075 9.277.211 3.132.316 6.217.234 9.429a1.945 1.945 0 0 1-.984 1.779 1.977 1.977 0 0 1-2.045-.055 1.943 1.943 0 0 1-.887-1.828v-.197l.07-.012Zm7.027-.386a65.998 65.998 0 0 0 3.206-9.634 57.684 57.684 0 0 0 1.661-10.103c.27-3.421.048-6.863-.66-10.221a25.835 25.835 0 0 0-1.626-4.882A23.21 23.21 0 0 0 398.5 286a23.156 23.156 0 0 1 3.17 4.201 26.629 26.629 0 0 1 2.145 4.846 37.847 37.847 0 0 1 1.673 10.562 59.64 59.64 0 0 1-.742 10.643 68.146 68.146 0 0 1-2.44 10.491 1.969 1.969 0 0 1-2.427 1.166 1.958 1.958 0 0 1-1.32-2.34.643.643 0 0 1 0-.164l.094-.141Zm19.983 6.156a24.293 24.293 0 0 0 3.355-1.966 20.384 20.384 0 0 0 3.04-2.488 12.374 12.374 0 0 0 2.33-3.114 7.565 7.565 0 0 0 .804-3.852 7.861 7.861 0 0 1 .105 4.159 12.921 12.921 0 0 1-1.713 3.954 22.572 22.572 0 0 1-2.632 3.409 28.098 28.098 0 0 1-3.227 3.046 1.997 1.997 0 0 1-1.932.309 1.92 1.92 0 0 1-1.24-1.477 1.886 1.886 0 0 1 .691-1.787c.119-.092.248-.172.384-.238l.035.045Z'
				fill='#231F20'
			/>
			<path
				d='M403.268 324.499a27.728 27.728 0 0 0 3.244-3.747 51.82 51.82 0 0 0 1.421-2.119c.45-.714.888-1.464 1.267-2.237a31.61 31.61 0 0 0 3.22-9.765c.162-.851.265-1.711.308-2.576.098-.867.138-1.739.118-2.611l-.059-2.623c-.083-.878-.225-1.744-.343-2.611l-.178-1.311a12.638 12.638 0 0 0-.296-1.288l-.639-2.576c-.486-1.71-1.184-3.349-1.776-5.035.746 1.616 1.598 3.208 2.249 4.871l.888 2.552c.143.422.32.844.427 1.277l.296 1.323c.201.878.426 1.756.592 2.646l.343 2.693c.109.905.152 1.817.13 2.728.042.914.018 1.83-.071 2.74a33.938 33.938 0 0 1-2.486 10.749c-.332.867-.77 1.698-1.184 2.553a35.155 35.155 0 0 1-1.338 2.458 30.45 30.45 0 0 1-3.386 4.684 1.99 1.99 0 0 1-3.422-.635 1.944 1.944 0 0 1 .462-1.953l.118-.128.095-.059Zm6.707.6a12.876 12.876 0 0 0 2.672-.847 15.977 15.977 0 0 0 2.591-1.436 14.314 14.314 0 0 0 4.16-4.389 17.725 17.725 0 0 0 2.126-5.884 9.41 9.41 0 0 0 .209-1.612l.14-1.624c0-1.095 0-2.189-.082-3.307.186 1.083.407 2.177.57 3.283l.104 1.671c.047.56.047 1.123 0 1.683l-.093 1.706a16.761 16.761 0 0 1-.29 1.683 8.314 8.314 0 0 1-.407 1.683c-.197.541-.337 1.118-.581 1.647a16.464 16.464 0 0 1-4.043 5.778c-.87.825-1.82 1.558-2.835 2.189-.51.324-1.038.619-1.58.883-.579.293-1.176.545-1.79.753a1.949 1.949 0 0 1-2.256-1.345c-.3-.969.173-2.01 1.095-2.409l.278-.071.012-.035Z'
				fill='#231F20'
			/>
			<path
				d='M367.5 350.036a30 30 0 0 0 55.008 16.533 29.997 29.997 0 0 0-1.917-35.72 30.002 30.002 0 0 0-34.753-8.488 30.034 30.034 0 0 0-18.338 27.675Z'
				fill='#885223'
				stroke='#563217'
				strokeWidth='2.96'
			/>
			<ellipse cx='397.5' cy='349' rx='18' ry='22' fill='#231F20' />
			<circle cx='394.5' cy='340' r='5' fill='#fff' />
			<circle cx='390' cy='330.5' r='2.5' fill='#fff' />
			<circle cx='392' cy='352.5' r='1.5' fill='#fff' />
			<path
				d='M567.93 340.82a40.806 40.806 0 0 0 4.882-.797 47.983 47.983 0 0 0 4.834-1.334A29.29 29.29 0 0 0 586.5 334a25.843 25.843 0 0 1-3.759 3.365 35.37 35.37 0 0 1-4.385 2.748 48.942 48.942 0 0 1-4.729 2.187 44.366 44.366 0 0 1-5.083 1.672c-.885.157-1.749-.357-1.984-1.182-.235-.825.238-1.683 1.086-1.97h.284Zm-4.74-4.174a52.494 52.494 0 0 0 8.914-2.294 50.298 50.298 0 0 0 8.398-3.865 34.353 34.353 0 0 0 7.199-5.734A25.755 25.755 0 0 0 592.5 317a26.125 26.125 0 0 1-4.163 8.269 35.224 35.224 0 0 1-6.875 6.583 51.285 51.285 0 0 1-8.398 4.794 54.33 54.33 0 0 1-9.275 3.269 1.797 1.797 0 0 1-1.76-.384 1.614 1.614 0 0 1-.456-1.671 1.716 1.716 0 0 1 1.341-1.157.813.813 0 0 1 .156 0l.12-.057Zm-4.187-5.983a45.513 45.513 0 0 0 8.362-2.297 44.574 44.574 0 0 0 7.879-3.859 33.041 33.041 0 0 0 6.754-5.743A26.127 26.127 0 0 0 586.5 311a26.655 26.655 0 0 1-3.906 8.281 34.113 34.113 0 0 1-6.449 6.593 46.95 46.95 0 0 1-7.879 4.801 48.58 48.58 0 0 1-8.701 3.273c-.889.229-1.791-.322-2.014-1.229-.224-.907.315-1.827 1.204-2.056h.248Z'
				fill='#231F20'
			/>
			<path
				d='M563.04 329.062a50.796 50.796 0 0 0 6.858-6.779 58.654 58.654 0 0 0 5.685-7.959c.876-1.388 1.575-2.857 2.369-4.315.793-1.458 1.397-2.961 1.919-4.512A55.692 55.692 0 0 0 582.5 296a56.364 56.364 0 0 1-1.812 9.752c-.391 1.62-1.007 3.17-1.552 4.743-.545 1.573-1.184 3.112-2.001 4.627a59.491 59.491 0 0 1-5.153 8.7 52.791 52.791 0 0 1-6.704 7.82 1.748 1.748 0 0 1-2.299-.157 1.65 1.65 0 0 1-.069-2.25l.106-.092.024-.081Zm-12.453-.329a34.875 34.875 0 0 0 4.624-2.312 44.395 44.395 0 0 0 4.386-2.982 38.247 38.247 0 0 0 7.411-7.524 35.86 35.86 0 0 0 2.833-4.473c.38-.786.712-1.607 1.079-2.416.166-.404.38-.797.51-1.225l.391-1.271a34.612 34.612 0 0 0 1.542-10.53c.32 3.598.08 7.222-.712 10.749l-.296 1.329c-.119.443-.261.879-.427 1.306-.308.856-.581 1.723-.913 2.578a38.483 38.483 0 0 1-2.573 4.878 40.274 40.274 0 0 1-7.113 8.506 48.967 48.967 0 0 1-4.399 3.468 37.301 37.301 0 0 1-4.909 2.994 1.76 1.76 0 0 1-1.719-.067 1.67 1.67 0 0 1-.801-1.486 1.675 1.675 0 0 1 .92-1.418l.118-.058.048-.046Z'
				fill='#231F20'
			/>
			<path
				d='M554.342 320.86a15.142 15.142 0 0 0 1.615-1.34 19.211 19.211 0 0 0 1.57-1.619 29.6 29.6 0 0 0 2.81-3.634 44.719 44.719 0 0 0 4.303-8.375l.818-2.248c.266-.757.454-1.537.686-2.329.498-1.526.785-3.122 1.106-4.659.321-1.538.52-3.192.785-4.799L568.5 287l-.022 4.857c-.133 1.619-.188 3.261-.398 4.892-.21 1.631-.399 3.261-.775 4.869-.166.803-.298 1.619-.508 2.411l-.653 2.329a46.284 46.284 0 0 1-3.783 9.179 36.325 36.325 0 0 1-2.732 4.274 23.01 23.01 0 0 1-3.495 3.809c-.694.592-1.711.48-2.273-.25s-.456-1.802.237-2.394l.133-.093.111-.023Zm-7.536-1.546a256.634 256.634 0 0 0 8.185-14.204 112.774 112.774 0 0 0 3.648-7.364A43.939 43.939 0 0 0 561.5 290a44.558 44.558 0 0 1-2.097 8.067 121.019 121.019 0 0 1-2.93 7.794 245.806 245.806 0 0 1-6.84 15.193c-.415.852-1.413 1.191-2.228.757-.815-.435-1.139-1.478-.724-2.33l.091-.155.034-.012Z'
				fill='#231F20'
			/>
			<path
				d='M543.527 321.376c-.071-2.8 0-5.482.2-8.165.171-2.736.486-5.461.944-8.165a46.888 46.888 0 0 1 1.982-7.919A22.718 22.718 0 0 1 550.5 290a22.023 22.023 0 0 0-3.009 7.36 44.632 44.632 0 0 0-1.109 7.885 74.313 74.313 0 0 0-.082 7.954c.106 2.636.306 5.319.648 7.885a1.697 1.697 0 0 1-1.474 1.901 1.71 1.71 0 0 1-1.924-1.458.54.54 0 0 1-.023-.151Zm-4.857.497a52.152 52.152 0 0 1-2.425-8.988 43.928 43.928 0 0 1-.732-9.127 27.8 27.8 0 0 1 1.667-8.999 21.813 21.813 0 0 1 2.14-4.164 20.613 20.613 0 0 1 3.157-3.595 19.16 19.16 0 0 0-2.71 3.792 20.304 20.304 0 0 0-1.625 4.187 26.16 26.16 0 0 0-.651 8.756c.245 2.92.798 5.816 1.653 8.651a51.03 51.03 0 0 0 3.198 8.269c.426.855-.038 1.844-1.037 2.209-.999.365-2.154-.032-2.581-.887 0 0-.027-.058-.054-.104Zm-16.022 7.738a24.155 24.155 0 0 1-2.933-2.638 20.545 20.545 0 0 1-2.444-2.977 11.355 11.355 0 0 1-1.565-3.396 6.539 6.539 0 0 1 .098-3.6 6.109 6.109 0 0 0 .745 3.328 10.071 10.071 0 0 0 2.127 2.694 19.876 19.876 0 0 0 2.774 2.151 24.6 24.6 0 0 0 3.043 1.698c.572.255.954.773 1.002 1.36.048.586-.246 1.151-.77 1.483a1.9 1.9 0 0 1-1.772.123 1.313 1.313 0 0 1-.305-.226Zm11.918-7.154a26.429 26.429 0 0 1-2.839-4.009 91.866 91.866 0 0 1-1.145-2.121 17.624 17.624 0 0 1-.95-2.19 29.576 29.576 0 0 1-2.094-9.269 17.578 17.578 0 0 1 0-2.318c-.018-.774.02-1.549.114-2.317l.263-2.318c.138-.765.332-1.518.492-2.317a35.145 35.145 0 0 1 1.351-4.415c.55-1.425 1.271-2.793 1.889-4.183-.492 1.448-1.076 2.862-1.488 4.322a32.875 32.875 0 0 0-.939 4.438c-.091.753-.206 1.495-.275 2.248v2.248a14.78 14.78 0 0 0 .103 2.236c.033.743.117 1.483.252 2.213a27.606 27.606 0 0 0 2.702 8.378c.32.66.709 1.274 1.053 1.912.343.637.789 1.228 1.144 1.831a22.887 22.887 0 0 0 2.725 3.209l.057.058c.667.64.695 1.706.063 2.381a1.649 1.649 0 0 1-2.352.064l-.126-.081Zm-4.149.477a13.815 13.815 0 0 1-2.879-1.415 16 16 0 0 1-2.432-1.898 14.604 14.604 0 0 1-3.442-5.022 16.76 16.76 0 0 1-1.147-5.835c-.069-.978.092-1.956.115-2.911.023-.955.332-1.91.493-2.853 0 .967-.069 1.921-.069 2.864.049.944.145 1.884.287 2.818a15.294 15.294 0 0 0 1.824 5.139 12.493 12.493 0 0 0 3.545 3.808c.702.487 1.447.905 2.225 1.249.736.331 1.506.577 2.295.731.849.219 1.391 1.073 1.244 1.96-.147.886-.935 1.507-1.806 1.423l-.253-.058Z'
				fill='#231F20'
			/>
			<path
				d='M569.5 342.989a26 26 0 0 1-47.667 14.381 25.997 25.997 0 0 1 1.657-30.97 26 26 0 0 1 30.133-7.347 25.985 25.985 0 0 1 15.877 23.936Z'
				fill='#885223'
				stroke='#563217'
				strokeWidth='2.56'
			/>
			<ellipse cx='543' cy='342' rx='15.5' ry='19' fill='#231F20' />
			<circle cx='545' cy='334.5' r='4.5' fill='#fff' />
			<circle cx='549.5' cy='325' r='2' fill='#fff' />
			<circle cx='547' cy='344.5' r='1.5' fill='#fff' />
			<path
				d='M261.488 435.897c.558 14.083-19.071 17.034-19.071 17.034-28.602 1.801-39.084-32.151-44.226-52.217-3.482-13.42 6.965-23.053 14.15-27.956 1.33-.871 3.012-1 4.459-.343a4.65 4.65 0 0 1 2.68 3.585c1.845 13.734 7.87 41.934 25.595 28.85'
				fill='#563217'
			/>
			<path
				d='M465.793 418.812s3.25-17.045 17.956-13.265c14.706 3.78 21.794 16.882 17.518 25.924-4.276 9.041-17.357 4.783-23.246 2.578 0 0-14.764-6.055-12.228-15.237Zm86.483 4.787s-2.557-17.412-17.327-14.205c-14.77 3.208-22.338 16.217-18.428 25.569 3.911 9.351 17.064 5.563 22.935 3.551.103.023 15.033-5.505 12.82-14.915Z'
				fill='#563217'
				stroke='#563217'
				strokeWidth='3.47'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M477.047 24s14.456 68.955-24.396 71.376c-33.325 2.095 24.603 52.289 41.92 66.662a8.502 8.502 0 0 0 11.055-.163c11.468-9.985 29.291-42.502-28.579-137.875Z'
				fill='url(#daisy__u)'
			/>
			<path
				d='M210.784 305s-9.298-10.829-34.495-11.852c0 0 22.327-5.677 20.432-16.494-1.894-10.817 8.914-17.319 3.766-25.659 0 0 15.446-20.994 10.297-35.534-5.149-14.539-37.284-20.425-37.284-20.425s19.27 3.036 19.27-13.329c0-16.366-3.603-63.682-11.843-68.881 0 0 10.297 5.536 16.991-6.782 6.695-12.317 19.758-19.529 12.215-32.416 0 0 14.563 18.877 33.612 13.306C262.793 81.363 272.056 36 272.056 36s31.38 25.252 50.975 23.705c19.595-1.547 39.132 9.794 41.713 13.958 2.58 4.164 19.606-25.287-9.786-33.01-29.393-7.724 27.893-2.06 53.834 8.758 13.33 5.548 39.074 18.61 62.423 33.813a49.255 49.255 0 0 1 22.226 38.815 49.266 49.266 0 0 1-18.333 40.802 21.306 21.306 0 0 1-13.354 4.652H351.866l-53.032 14.272-42.735 19.855-18.537 24.426-17.503 21.669s-11.332 35.127-9.275 57.285Z'
				fill='url(#daisy__v)'
			/>
			<path
				d='M612.5 277s-12.922-23.038-15.469-12.799c-2.547 10.239-11.531-32.474-11.531-32.474s6.321-10.134 27 45.273Z'
				fill='url(#daisy__w)'
			/>
			<path
				d='M613.5 295s-20.076-32.046-34.784-17.937c-14.708 14.11-9.21-45.085-9.21-45.085S594.892 218.089 613.5 295Z'
				fill='url(#daisy__x)'
			/>
			<path
				d='M598.5 294s-11.066-24.546-17.838-14.558-6.147-33.871-6.147-33.871S586.565 236.13 598.5 294Z'
				fill='url(#daisy__y)'
			/>
			<path
				d='M170.5 124s12.636 29.563 26.291 19.294c13.656-10.27 2.237 39.325 2.237 39.325S176.73 191.459 170.5 124Z'
				fill='url(#daisy__z)'
			/>
			<path
				d='M604.5 413s-11.574-49.577-22.129-32.036c-10.555 17.54-3.657-66.272-3.657-66.272S596.306 299.363 604.5 413Z'
				fill='url(#daisy__A)'
			/>
			<path
				d='M605.5 338s-15.756-39.085-24.648-23.514c-8.891 15.571-9.352-53.631-9.352-53.631s16.056-14.628 34 77.145Z'
				fill='url(#daisy__B)'
			/>
			<path
				d='M598.5 342s-11.066-24.553-17.838-14.555c-6.772 9.998-6.147-33.866-6.147-33.866s12.05-9.498 23.985 48.421Z'
				fill='url(#daisy__C)'
			/>
			<path
				d='M593.5 398s-4.976-25.529-10.357-16.713c-5.382 8.816-.878-33.965-.878-33.965s8.758-7.565 11.235 50.678Z'
				fill='url(#daisy__D)'
			/>
			<path
				d='M611.5 392s-10.373-24.545-14.173-14.622c-3.8 9.924-7.827-33.813-7.827-33.813s7.6-9.396 22 48.435Z'
				fill='url(#daisy__E)'
			/>
			<path
				d='M191.5 74s12.635 30.037 26.288 19.657c13.654-10.379 2.249 39.959 2.249 39.959S197.73 142.567 191.5 74Z'
				fill='url(#daisy__F)'
			/>
			<path
				d='M239.064 40s3.271 40.242 27.649 37.442c24.379-2.8-16.272 44.558-16.272 44.558s-35.885-4.096-11.377-82Z'
				fill='url(#daisy__G)'
			/>
			<path
				d='M168.5 229s19.139 22.03 39.819 14.412c20.681-7.618 3.453 29.307 3.453 29.307S177.937 279.278 168.5 229Z'
				fill='url(#daisy__H)'
			/>
			<path
				d='M206.5 290s11.996-9.709 8.331-20.736c-3.664-11.027 15.579-1.307 15.579-1.307s2.876 17.882-23.91 22.043Z'
				fill='#F6921E'
			/>
			<path
				d='M194.5 311s16.975-14.584 11.82-31.107c-5.156-16.523 22.06-1.974 22.06-1.974s3.982 26.846-33.88 33.081Z'
				fill='#F6921E'
			/>
			<path
				d='M193.5 345s16.943-14.683 11.797-31.308C200.152 297.067 227.385 282 227.385 282s3.906 56.722-33.885 63Z'
				fill='url(#daisy__I)'
			/>
			<path
				d='M180.5 211.941s25.299 1.894 25.552 17.963c.253 16.068 26.448-10.995 26.448-10.995s-5.451-23.612-52-6.968Z'
				fill='url(#daisy__J)'
			/>
			<path
				d='M314.6 31s12 22.575-1.998 31.48C298.604 71.387 336.521 79 336.521 79s17.808-17.453-21.921-48Z'
				fill='url(#daisy__K)'
			/>
			<path
				d='M395.44 0s39.55 57.891 4.283 75.027C364.455 92.163 469.807 122 469.807 122S512.818 85.494 395.44 0Z'
				fill='url(#daisy__L)'
			/>
			<path
				d='M292.5 280s-42.961-55.254-9.107-74.65c33.854-19.395-72.515-42.35-72.515-42.35s-40.282 39.243 81.622 117Z'
				fill='url(#daisy__M)'
			/>
			<path
				d='M260.5 277s-20.616-23.675-5.395-31.226C270.327 238.223 221.134 227 221.134 227s-17.847 15.722 39.366 50Z'
				fill='#F6921E'
			/>
			<path
				d='M232.217 289s-5.599-28.374 11.694-32.655C261.205 252.063 224.048 230 224.048 230s-23.872 11.929 8.169 59Z'
				fill='#F6921E'
			/>
			<path
				d='M237.742 327s-7.971-31.479 11.364-49.931c13.277-12.605-33-31.069-33-31.069s-32.331 24.416 21.636 81Z'
				fill='url(#daisy__N)'
			/>
			<path
				d='M224.217 363s-5.599-28.368 11.694-32.649c17.294-4.28-19.863-26.351-19.863-26.351s-23.872 11.938 8.169 59Z'
				fill='url(#daisy__O)'
			/>
			<path
				d='M251.5 338s-17.234-24.083-14.649-42.086c2.011-14.269-21.37 15.069-21.37 15.069S200.775 313.457 251.5 338Z'
				fill='url(#daisy__P)'
			/>
			<path
				d='m227.857 206-18.408 37.05-4.949 28.877L208.289 285l9.01-9.919 15.837-27.529 10.364-20.964L227.857 206Z'
				fill='url(#daisy__Q)'
			/>
			<path
				d='M211.5 289s10.17-14.28 10.17-19.172c0-4.892 12.34-9.296 12.34-19.463 0 0 14.663-3.962 14.663-18.591a23.004 23.004 0 0 0 23.915-12.352s22.522 3.091 24.379-13.13c0 0 22.673 11.62 31.159-11.619 0 0 14.663 17.766 32.402-7.715 0 0 10.378 15.442 30.648-3.091 0 0 20.641 17.754 36.279 0 0 0 14.964 13.943 31.113 0 0 0 14.755 12.351 30.102 0 0 0 15.801 19.3 25.216 18.591 9.415-.709 18.574-.778 18.574-.778l26.04 2.393-1.463-3.602a158.014 158.014 0 0 0-13.931-26.632l-5.503-8.505-7.244-9.656a99.671 99.671 0 0 0-14.662-15.675l-6.083-5.252h-60.647s-204.323-17.429-235.459 115.614L211.5 289Z'
				fill='#FAF9DF'
			/>
			<path
				d='M553.553 152.226s14.213-19.381 15.984-7.212c1.771 12.169 2.035 33.726-7.601 35.878-9.637 2.153-8.383-28.666-8.383-28.666Z'
				fill='#BBBDBF'
			/>
			<path
				d='m537.5 165.653 1.539-40.87s16.446-28.482 21.333 3.117a200.287 200.287 0 0 1-.129 59.1l-13.239-3.706-9.504-17.641Z'
				fill='#E6E7E8'
			/>
			<path
				d='M518.5 113.259s19.093-22.354 20.716 11.393C540.839 158.398 545.5 169 545.5 169l-7.734-3.197-19.266-52.544Z'
				fill='#E6E7E8'
			/>
			<path
				d='M514.461 140.808s-13.279-45.76-9.173-46.795c4.105-1.035 43.654 60.219 36.304 80.61-7.351 20.39-20.4-7.957-20.4-7.957l-2.958-18.029-3.773-7.829Z'
				fill='#BBBDBF'
			/>
			<path
				d='M499.34 139.426S483.607 97 490.049 97c6.443 0 31.657 38.291 29.296 51.747-2.362 13.457-20.005-9.321-20.005-9.321Z'
				fill='#D0D2D3'
			/>
			<path d='M571.126 202s15.553-14.299 6.592-25.229c-8.96-10.929-13.779-3.639-18.218 0' fill='#fff' />
			<path
				d='M535.099 189s-46.224-39.652-51.833-45.868c-3.039-3.37 2.031-27.64 32.265-6.718 30.235 20.923 30.969 47.536 30.969 47.536L535.099 189Zm31.497 2s53.581 22.076 39.567 37.302c-14.015 15.227-29.196 11.222-29.196 11.222l-16.467-21.25L566.596 191Z'
				fill='#E6E7E8'
			/>
			<path
				d='M568.782 208.029s71.674 35.26 44.613 39.138c-27.06 3.879-36.753-7.049-36.753-7.049l-14.291-7.324s-9.6-25.769 6.431-24.765Z'
				fill='#E6E7E8'
			/>
			<path d='M579.719 244.14s33.431 18.129 37.327 12.919c0 0 8.038-23.805-43.546-31.059' fill='#BBBDBF' />
			<path
				d='M530.216 173s-7.867 57.229 3.177 66.8c11.045 9.571 19.006 10.736 24.109-3.493 5.103-14.229-1.181-35.362-1.181-35.362l-17.092-21.751-9.013-6.194Z'
				fill='#E6E7E8'
			/>
			<path
				d='M562.812 222.14s12.044 40.605 31.64 50.86c0 0 14.557 0 4.515-17.715-10.043-17.715-22.354-34.804-30.418-37.634-8.065-2.831-5.737 4.489-5.737 4.489Z'
				fill='#D0D2D3'
			/>
			<path
				d='M533.123 161.1s-44.715-20.671-44.623-7.977c.093 12.694 17.958 35.424 50.84 33.794 32.882-1.63-6.217-25.817-6.217-25.817Z'
				fill='#BBBDBF'
			/>
			<path
				d='M536.499 174s-33.087 15.702-23.131 22.204c9.955 6.501 29.221 10.623 33.379-5.033C550.904 175.514 536.499 174 536.499 174Zm9.001 25.366s7.945 82.844 13.041 82.634c5.096-.211 18.546-11.101 8.07-62.447-10.476-51.346-21.111-20.187-21.111-20.187Z'
				fill='#fff'
			/>
			<path
				d='M540.884 158.502c-2.469-1.168-5.426-.235-6.766 2.136-2.518 4.616-3.62 14.45 8.506 34.36 8.124 13.377 14.181 19.84 18.452 22.853a6.2 6.2 0 0 0 5.932.692 6.146 6.146 0 0 0 3.746-4.628c1.938-11.877 2.495-39.843-29.87-55.413Z'
				fill='#FAAF40'
			/>
			<circle cx='236' cy='238.5' r='4.5' fill='#F6921E' />
			<circle cx='258' cy='219.5' r='4.5' fill='#F6921E' />
			<circle cx='282' cy='207.5' r='6.5' fill='#F6921E' />
			<circle cx='310' cy='195.5' r='6.5' fill='#885223' />
			<circle cx='341' cy='186.5' r='6.5' fill='#885223' />
			<circle cx='374' cy='179.5' r='6.5' fill='#885223' />
			<circle cx='409' cy='176.5' r='7.5' fill='#885223' />
			<circle cx='442' cy='174.5' r='7.5' fill='#885223' />
			<circle cx='472' cy='172.5' r='7.5' fill='#885223' />
			<circle cx='224.5' cy='254' r='4' fill='#F6921E' />
			<path
				d='M561.5 474.842a82.447 82.447 0 0 1-18.003 15.177 104.074 104.074 0 0 1-21.397 10.236 107.587 107.587 0 0 1-47.314 5.001l-5.927-.897-1.476-.224-1.465-.318-2.929-.637-2.917-.649c-.976-.224-1.918-.542-2.882-.801-1.918-.567-3.836-1.097-5.73-1.687l-5.602-2.052c-.93-.354-1.871-.672-2.789-1.049l-2.72-1.18-5.416-2.441-5.242-2.783A149.909 149.909 0 0 1 392.5 462c13.273 8.113 26.627 15.649 40.527 21.522l5.207 2.181 5.288 1.934 2.627.955 2.684.838 5.335 1.663c3.626.849 7.171 1.969 10.832 2.57l2.731.543 1.36.283 1.371.2 5.486.779a125.794 125.794 0 0 0 44.06-2.63 131.62 131.62 0 0 0 41.492-17.996Z'
				fill='#AF6751'
			/>
			<path
				d='M267.5 829.079s62.196 43.819 173.917 38.468l15.083-41.881L395.05 783l-100.567 14.103-26.983 31.976Z'
				fill='#FAF9DF'
			/>
			<defs>
				<linearGradient
					id='daisy__a'
					x1='612.639'
					y1='1040.71'
					x2='660.292'
					y2='619.674'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.06' stopColor='#583107' />
					<stop offset='.16' stopColor='#724318' />
					<stop offset='.29' stopColor='#885223' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__b'
					x1='269.759'
					y1='795.209'
					x2='442.613'
					y2='587.631'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FFD54F' />
					<stop offset='.73' stopColor='#DFB741' />
					<stop offset='1' stopColor='#A5812E' />
				</linearGradient>
				<linearGradient
					id='daisy__c'
					x1='180.477'
					y1='643.055'
					x2='409.453'
					y2='643.055'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient id='daisy__d' x1='534.887' y1='618.12' x2='558.759' y2='434.3' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FFD54F' />
					<stop offset='1' stopColor='#A5812E' />
				</linearGradient>
				<linearGradient
					id='daisy__e'
					x1='486.498'
					y1='888.991'
					x2='668.492'
					y2='888.991'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.06' stopColor='#583107' />
					<stop offset='.16' stopColor='#724318' />
					<stop offset='.29' stopColor='#885223' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__f'
					x1='667.692'
					y1='402.856'
					x2='510.174'
					y2='405.817'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient
					id='daisy__g'
					x1='729.197'
					y1='444.563'
					x2='586.595'
					y2='449.176'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FFD54F' />
					<stop offset='.73' stopColor='#DFB741' />
					<stop offset='1' stopColor='#A5812E' />
				</linearGradient>
				<linearGradient
					id='daisy__h'
					x1='449.148'
					y1='533.655'
					x2='374.241'
					y2='702.361'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient id='daisy__i' x1='-42.883' y1='555.465' x2='27.291' y2='615.636' gradientUnits='userSpaceOnUse'>
					<stop offset='.15' stopColor='#BE1E2D' />
					<stop offset='.7' stopColor='#97181E' />
					<stop offset='1' stopColor='#6C0206' />
				</linearGradient>
				<linearGradient id='daisy__j' x1='91.453' y1='814.993' x2='347.5' y2='814.993' gradientUnits='userSpaceOnUse'>
					<stop offset='.11' stopColor='#F6921E' />
					<stop offset='.49' stopColor='#FAAF40' />
					<stop offset='1' stopColor='#F05A28' />
				</linearGradient>
				<linearGradient
					id='daisy__k'
					x1='-79.748'
					y1='556.555'
					x2='-69.882'
					y2='789.862'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' stopOpacity='.6' />
					<stop offset='.23' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient id='daisy__l' x1='510.5' y1='851.001' x2='567.501' y2='851.001' gradientUnits='userSpaceOnUse'>
					<stop offset='.11' stopColor='#F6921E' />
					<stop offset='.49' stopColor='#FAAF40' />
					<stop offset='1' stopColor='#F05A28' />
				</linearGradient>
				<linearGradient
					id='daisy__m'
					x1='-31.988'
					y1='613.475'
					x2='-28.607'
					y2='681.407'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' stopOpacity='.6' />
					<stop offset='.11' stopColor='#F6921E' />
					<stop offset='.49' stopColor='#FAAF40' />
					<stop offset='1' stopColor='#F05A28' />
				</linearGradient>
				<linearGradient
					id='daisy__n'
					x1='179.064'
					y1='551.035'
					x2='208.075'
					y2='551.035'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient
					id='daisy__o'
					x1='252.721'
					y1='477.903'
					x2='202.394'
					y2='478.679'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient id='daisy__p' x1='225.291' y1='319.247' x2='66.321' y2='375.195' gradientUnits='userSpaceOnUse'>
					<stop offset='.06' stopColor='#583107' />
					<stop offset='.16' stopColor='#724318' />
					<stop offset='.29' stopColor='#885223' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__q'
					x1='211.501'
					y1='564.999'
					x2='581.495'
					y2='564.999'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.06' stopColor='#583107' />
					<stop offset='.16' stopColor='#724318' />
					<stop offset='.29' stopColor='#885223' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__r'
					x1='280.046'
					y1='391.048'
					x2='285.395'
					y2='616.694'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FDE5D6' />
					<stop offset='.22' stopColor='#F5BF98' />
					<stop offset='.66' stopColor='#DB9E71' />
					<stop offset='.95' stopColor='#946C4C' />
				</linearGradient>
				<linearGradient
					id='daisy__s'
					x1='475.034'
					y1='432.536'
					x2='591.044'
					y2='432.753'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FDE5D6' />
					<stop offset='.22' stopColor='#F5BF98' />
					<stop offset='.66' stopColor='#DB9E71' />
					<stop offset='.95' stopColor='#946C4C' />
				</linearGradient>
				<linearGradient
					id='daisy__t'
					x1='310.056'
					y1='286.426'
					x2='325.153'
					y2='441.154'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FDE5D6' />
					<stop offset='.22' stopColor='#F5BF98' />
					<stop offset='.66' stopColor='#DB9E71' />
					<stop offset='.95' stopColor='#946C4C' />
				</linearGradient>
				<linearGradient id='daisy__u' x1='435.26' y1='-20.905' x2='445.162' y2='136.288' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__v' x1='137.182' y1='46.753' x2='187.104' y2='292.341' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__w' x1='595.94' y1='163.678' x2='495.169' y2='193.309' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__x'
					x1='593.116'
					y1='177.307'
					x2='491.653'
					y2='219.887'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__y'
					x1='601.495'
					y1='152.668'
					x2='503.543'
					y2='172.897'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__z' x1='139.867' y1='-15.46' x2='149.278' y2='142.308' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__A'
					x1='657.829'
					y1='144.805'
					x2='566.474'
					y2='151.071'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__B'
					x1='618.514'
					y1='160.316'
					x2='522.523'
					y2='176.124'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__C' x1='625.008' y1='180.402' x2='527.07' y2='200.627' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__D'
					x1='659.896'
					y1='136.076'
					x2='571.663'
					y2='141.085'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__E'
					x1='659.658'
					y1='204.194'
					x2='560.263'
					y2='221.032'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__F' x1='161.802' y1='-18.02' x2='171.532' y2='142.319' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__G' x1='207.974' y1='-17.496' x2='218.241' y2='140.8' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__H' x1='50.024' y1='167.263' x2='95.51' y2='373.828' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__I'
					x1='107.223'
					y1='198.852'
					x2='236.886'
					y2='329.101'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__J' x1='9.412' y1='157.102' x2='27.757' y2='355.941' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__K'
					x1='272.213'
					y1='-17.985'
					x2='279.265'
					y2='140.125'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__L'
					x1='377.537'
					y1='-21.017'
					x2='383.542'
					y2='137.743'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__M' x1='152.91' y1='164.839' x2='246.099' y2='347.525' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__N' x1='132.82' y1='189.607' x2='261.804' y2='325.904' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient
					id='daisy__O'
					x1='114.287'
					y1='193.081'
					x2='241.771'
					y2='332.617'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__P' x1='94.945' y1='172.702' x2='175.749' y2='367.113' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
				<linearGradient id='daisy__Q' x1='141.537' y1='192.614' x2='274.754' y2='307.62' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FBAF28' />
					<stop offset='.26' stopColor='#FBAF28' />
					<stop offset='.44' stopColor='#F6921E' />
					<stop offset='.62' stopColor='#FBAF28' />
					<stop offset='1' stopColor='#E1771D' />
				</linearGradient>
			</defs>
		</SvgIcon>
	);
};

export const TitleText: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<SvgIcon fill='none' height={709} width={1187} {...props}>
			<path
				d='M613.5 673a198.767 198.767 0 0 0 4-2 160.3 160.3 0 0 1-4 2Zm-585-368c4.285-3.633 8.67-7.701 13-12a271.01 271.01 0 0 1-13 12Zm21-19Zm19-22a142.37 142.37 0 0 1-4 7c1.391-2.288 2.734-4.588 4-7Z'
				fill='#BCBEC0'
			/>
			<path
				d='m1111 618.82-5.61-5.82H902.247L850.5 674.769l.418-.128a80.204 80.204 0 0 0 21.18 18.751C889.177 703.867 910.937 709 938.6 709h82.06c30.73 0 58.56-18.704 76.4-51.317a147.414 147.414 0 0 0 8.32-18.181c2.5-6.575 4.54-13.315 6.12-20.17l-.5-.512Z'
				fill='url(#titleText__a)'
			/>
			<path
				d='m735.213 671-.503.214-.21.248c13.617 6.132 29.222 9.772 46.954 11.024 4.676.338 9.491.507 14.447.507 18.385.16 36.691-2.34 54.307-7.417l.292-.349a190.222 190.222 0 0 1-53.874 7.304c-23.915-.045-44.207-3.799-61.413-11.531Z'
				fill='#1C75BC'
			/>
			<path
				d='M847.469 620.835a189.674 189.674 0 0 1-21.084-1.155A128.741 128.741 0 0 1 786.379 609L734.5 670.401l.5-.219c17.119 7.92 37.308 11.811 61.102 11.811a184.152 184.152 0 0 0 53.6-7.482l51.798-61.274a184.129 184.129 0 0 1-54.031 7.598Z'
				fill='url(#titleText__b)'
			/>
			<path
				d='M677.518 681.524c-23.949 0-43.455-3.795-59.32-11.524l-.698.476C633.354 678.217 652.859 682 676.82 682c22.984 0 41.873-3.482 57.471-10.712l.209-.255c-15.47 7.091-34.231 10.491-56.982 10.491Z'
				fill='#D7DF23'
			/>
			<path
				d='M677.546 681c22.766 0 41.54-3.484 57.032-10.452l51.922-61.723c-15.573 7.188-34.51 10.707-57.509 10.707-19.158 0-35.464-2.427-49.35-7.351A97.844 97.844 0 0 1 669.632 608L617.5 669.991l.698-.476C634.062 677.249 653.581 681 677.546 681Z'
				fill='url(#titleText__c)'
			/>
			<path
				d='m454.206 671-.498.242-.208.241a151.5 151.5 0 0 0 55.669 23.019A135.374 135.374 0 0 0 534.62 697a143.899 143.899 0 0 0 77.88-23.514 143.912 143.912 0 0 1-77.175 23.019c-27.811-.023-57.01-9.254-81.119-25.505Z'
				fill='#1C75BC'
			/>
			<path
				d='M668.5 608a142.983 142.983 0 0 1-81.952 26.451 144.869 144.869 0 0 1-61.957-14.597 151.157 151.157 0 0 1-19.381-11.133l-51.71 61.792.498-.244C478.155 686.679 507.412 696 535.336 696a143.401 143.401 0 0 0 77.328-23.244 130.887 130.887 0 0 0 3.917-2.707L668.5 608Z'
				fill='url(#titleText__d)'
			/>
			<path
				d='M398.421 681.526c-15.487 0-35.098-1.005-53.203-8.238l-.463.173-.255.301c18.105 7.244 37.727 8.238 53.214 8.238 5.722 0 12.07-.173 18.765-.832a106.995 106.995 0 0 0 36.812-9.925l.209-.243c-19.228 9.371-39.488 10.526-55.079 10.526Z'
				fill='#D7DF23'
			/>
			<path
				d='M421.367 617.994a110.548 110.548 0 0 1-25.006-6.474L344.5 672.931l.465-.174c18.17 7.237 37.852 8.243 53.395 8.243 15.544 0 35.981-1.237 55.279-10.532L505.5 609c-19.449 9.526-40.003 10.763-55.802 10.763a197.068 197.068 0 0 1-28.331-1.769Z'
				fill='url(#titleText__e)'
			/>
			<path
				d='M293.883 681.525c-17.034 0-31.83-2.058-44.687-6.211l-.696.475a135.481 135.481 0 0 0 34.882 5.955c3.191.159 6.44.256 9.805.256 21.061 0 37.33-2.765 51.058-8.683l.255-.317c-13.658 5.87-29.788 8.525-50.617 8.525Z'
				fill='#1C75BC'
			/>
			<path
				d='M345.98 619.36a175.304 175.304 0 0 1-30.5-2.468 124.28 124.28 0 0 1-14.571-3.493L248.5 675.516l.702-.454c12.968 3.97 27.89 5.938 45.071 5.938 21.067 0 37.277-2.585 51.052-8.15L397.5 611c-13.869 5.729-30.278 8.36-51.52 8.36Z'
				fill='url(#titleText__f)'
			/>
			<path
				d='M172.639 695.441c-57.989 0-92.332-24.605-110.927-45.24a134.155 134.155 0 0 1-27.542-47.744 158.573 158.573 0 0 1-7.956-50.387 188.803 188.803 0 0 1 22.363-87.942l-.21-.128-.502.606a188.81 188.81 0 0 0-22.363 88.023 158.551 158.551 0 0 0 7.944 50.375A134.348 134.348 0 0 0 61 650.748C79.595 671.394 113.938 696 171.916 696c31.345 0 56.473-6.777 76.584-20.623-19.971 13.496-44.877 20.064-75.861 20.064Z'
				fill='#D7DF23'
			/>
			<path
				d='M224.073 634.238c-57.86 0-92.133-24.6-110.689-45.242a134.143 134.143 0 0 1-27.486-47.663 158.852 158.852 0 0 1-7.94-50.376c.011-7.219.459-14.431 1.339-21.596A190.644 190.644 0 0 1 100.252 403l-51.643 61.541.21.128a189.03 189.03 0 0 0-22.317 87.992 158.813 158.813 0 0 0 7.94 50.376 134.194 134.194 0 0 0 27.486 47.733C80.484 671.4 114.757 696 172.627 696c30.92 0 55.775-6.624 75.671-20.153l52.201-62.192c-20.07 13.807-45.146 20.583-76.427 20.583Z'
				fill='url(#titleText__g)'
			/>
			<path
				d='M37.5 239.647c0-13.498-.98-24.374-2.999-33.415v-.058a.972.972 0 0 0 0-.174l-.627.766c2.018 8.983 2.999 19.916 2.999 33.415a271.728 271.728 0 0 1-6.454 58.101A43.788 43.788 0 0 1 27.5 306c.25-.197.502-.418.764-.615a42.966 42.966 0 0 0 2.85-7.579 271.762 271.762 0 0 0 6.386-58.159Z'
				fill='#D7DF23'
			/>
			<path
				d='M46.226 289.76c1.036-.989 2.06-2.001 3.084-3.025a167.294 167.294 0 0 0 13.63-15.333 130.63 130.63 0 0 0 4.818-6.585 117.345 117.345 0 0 0 4.33-6.806c.605-1.093 1.164-2.152 1.793-3.188 4.26-7.55 7.635-13.53 9.031-18.974A267.598 267.598 0 0 0 89.5 177.61c0-13.53-1.001-24.489-3.061-33.494V144l-51.491 61.426a.965.965 0 0 1 0 .175v.058c2.06 9.016 3.061 19.964 3.061 33.494a267.709 267.709 0 0 1-6.6 58.25A42.596 42.596 0 0 1 28.5 305c4.481-3.49 9.067-7.399 13.594-11.529a69.287 69.287 0 0 0 4.132-3.711Z'
				fill='url(#titleText__h)'
			/>
			<path
				d='M42.841 462.026C16.635 445.565.835 416.354 1.205 385.05c0-30.587 12.214-52.595 21.14-68.619 2.358-4.255 4.428-7.995 6.05-11.431-.265.199-.518.421-.77.619-1.611 3.402-3.658 7.107-5.993 11.291-8.914 16.047-21.13 38.032-21.13 68.631a91.862 91.862 0 0 0 9.72 41.889c6.663 13.127 16.424 24.371 28.41 32.726L48.004 466l.495-.608c-1.932-1.028-3.83-2.197-5.659-3.366Z'
				fill='#1C75BC'
			/>
			<path
				d='M1.506 384.333c-.372 31.046 15.538 60.016 41.923 76.34 1.842 1.159 3.752 2.319 5.698 3.327l51.373-61.283c-2.015-1.101-4.007-2.237-5.906-3.477-26.39-16.327-42.3-45.303-41.923-76.352 0-2.643.104-5.216.278-7.731C54.663 290.664 64.24 272.153 72.173 258a98.454 98.454 0 0 1-4.308 6.781 130.434 130.434 0 0 1-4.794 6.561 166.615 166.615 0 0 1-13.562 15.277 190.86 190.86 0 0 1-3.069 3.014c-1.331 1.286-2.686 2.526-4.03 3.767a255.223 255.223 0 0 1-13.526 11.487c-1.633 3.408-3.718 7.117-6.092 11.336-8.987 15.973-21.286 37.811-21.286 68.11Z'
				fill='url(#titleText__i)'
			/>
			<path
				d='M46.5 290c-1.322 1.025-2.667 2.012-4 3 1.333-.988 2.678-1.975 4-3Zm16-19Zm-32.916-76.283c-6.909-11.213-17.361-28.16-17.361-50.691 0-21.016 9.563-40.333 26.925-54.402A77.466 77.466 0 0 1 45.5 85a82.085 82.085 0 0 0-7.11 5.11c-17.326 14.057-26.89 33.385-26.89 54.402 0 22.519 10.452 39.466 17.361 50.679 2.157 3.468 5.416 8.798 5.926 10.693V206l.652-.763c-.605-2.023-3.745-7.109-5.855-10.52Z'
				fill='#1C75BC'
			/>
			<path
				d='M12.5 143.359c0 22.689 10.232 39.755 16.995 51.047 2.065 3.493 5.139 8.557 5.707 10.594L86.5 143.51c-.44-1.909-3.643-7.24-5.8-10.756-1.613-2.701-3.48-5.739-5.255-9.092-5.8-10.687-11.74-24.691-11.74-41.909.002-2.59.145-5.178.43-7.753a101.353 101.353 0 0 0-19.06 9.907 81.696 81.696 0 0 0-6.219 4.656C21.862 102.742 12.5 122.195 12.5 143.36Z'
				fill='url(#titleText__j)'
			/>
			<path
				d='M1161.73 441.852a113.29 113.29 0 0 0-20.71-64.707 152.383 152.383 0 0 0 21.19-29.998c15.44-28.183 24.29-61.88 24.29-92.437 0-25.729-6.17-47.829-18.32-65.695a93.903 93.903 0 0 0-5.96-7.828 81.314 81.314 0 0 0 6-9.876c7.31-14.109 11.01-30.684 11.01-49.26 0-24.624-7.41-51.18-20.34-73C1140.39 17.878 1112.74 0 1083.02 0H945.1c-23.187 0-41.732 1.838-56.694 5.606a108.605 108.605 0 0 0-19.382 6.758l-.78-.267-1.652-.407 1.164-4.292-17.161 1.698a92.832 92.832 0 0 0-14.636-1.221 93.958 93.958 0 0 0-32.39 5.874l-15.473 1.523a62.19 62.19 0 0 0-3.654-1.454 81.453 81.453 0 0 0-27.864-4.652 97.821 97.821 0 0 0-25.06 3.257 123.82 123.82 0 0 0-28.678-3.257 102.333 102.333 0 0 0-18.115 1.582 61.118 61.118 0 0 0-8.423-1.07h-.058a98.92 98.92 0 0 0-17.987-1.792 94.375 94.375 0 0 0-35.287 6.98 67.34 67.34 0 0 0-2.571-.92 104.73 104.73 0 0 0-63.011 0 66.435 66.435 0 0 0-4.189 1.57 85.27 85.27 0 0 0-9.423-3.07 112.51 112.51 0 0 0-28.039-3.49 114.505 114.505 0 0 0-27.794 3.315 77.038 77.038 0 0 0-18.15 7.072 92.772 92.772 0 0 0-42.36-10.259h-19.906a100.276 100.276 0 0 0-31.506 4.85 70.962 70.962 0 0 0-19.278 9.957 160.753 160.753 0 0 0-29.284-12.946C306.692 4.083 283.005.605 257.037.605h-72.353c-15.788 0-39.22 1.5-61.208 8.665-13.17 4.304-24.432 10.271-33.437 17.762-17.045 14.156-26.433 33.604-26.433 54.75 0 22.659 10.261 39.711 17.044 51.005 2.117 3.49 5.328 8.84 5.817 10.748v.116c2.06 9.003 3.06 19.96 3.06 33.488a267.606 267.606 0 0 1-6.585 58.228c-1.396 5.443-4.77 11.422-9.028 18.971-9.052 16.029-21.407 37.896-21.407 68.348a88.804 88.804 0 0 0 42.127 76.618 266.998 266.998 0 0 0 5.934 3.489 188.862 188.862 0 0 0-22.303 87.924 158.67 158.67 0 0 0 7.934 50.33 134.004 134.004 0 0 0 27.469 47.62c18.545 20.623 52.796 45.201 110.619 45.201 31.261 0 56.321-6.77 76.379-20.588 12.879 3.966 27.713 5.92 44.803 5.92 21.117 0 37.428-2.628 51.191-8.293 18.185 7.293 37.881 8.293 53.436 8.293 15.788 0 36.358-1.244 55.845-10.829 24.246 16.424 53.611 25.753 81.638 25.753a143.786 143.786 0 0 0 82.254-26.474c15.869 7.758 35.38 11.55 59.335 11.55 22.989 0 41.883-3.489 57.485-10.724 17.126 7.979 37.323 11.887 61.115 11.887a183.008 183.008 0 0 0 54.053-7.653 80.26 80.26 0 0 0 21.174 18.704C940.098 641.882 961.889 647 989.59 647h82.17c30.78 0 58.65-18.68 76.51-51.272 11.49-20.996 18.09-46.201 18.09-69.139 0-18.204-3.98-34.372-11.84-48.178a90.71 90.71 0 0 0 7.21-36.559Z'
				fill='url(#titleText__k)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M397.308 103.874a68.49 68.49 0 0 0-1.456-14.505c-.755-3.358-2.423-6.091-3.854-8.437-1.331-2.181-2.458-4.028-2.458-5.731 0-4.886 9.341-7.201 18.565-7.201h19.779c24.635 0 41.616 26.01 41.616 50.915 0 20.938-12.011 39.085-41.384 39.085h-20.011c-16.507 0-21.605-5.014-21.605-11.481 0-4.506 1.972-8.02 4.093-11.799 1.674-2.982 3.44-6.129 4.404-10.059a91.256 91.256 0 0 0 2.311-20.787Zm21.964 5.13c0 8.143.729 19.298 8.74 19.298 9.097 0 12.715-8.677 12.715-18.204 0-11.714-5.467-24.661-12.715-24.661-6.682 0-8.74 8.422-8.74 18.437v5.13Zm20.034-31.268c-2.197 0-4.624-1.71-4.624-3.175 0-.966.971-1.478 2.057-1.454 2.197 0 4.624 1.698 4.624 3.164 0 .977-.971 1.465-2.057 1.465ZM562.5 147.461c0 11.708-9.331 12.539-20.994 12.539-13.996 0-21.425-2.342-21.425-11.801 0-1.235.077-2.98.162-4.879.101-2.262.211-4.741.211-6.829 0-5.046-.618-10.081-6.858-10.081-7.593 0-8.328 8.114-8.328 14.132 0 .854.029 1.726.058 2.604v.001c.029.889.059 1.785.059 2.675 0 10.818-5.832 14.143-18.486 14.143-9.179 0-16.399-1.967-16.399-11.708 0-5.619 2.376-6.926 5.586-8.693 2.97-1.635 6.655-3.663 9.833-9.864a207.547 207.547 0 0 0 11.395-27.771c1.831-5.655 3.056-9.471 3.056-14.143 0-3.798-1.378-6.175-2.613-8.305-1.004-1.73-1.913-3.298-1.913-5.334 0-4.18 11.384-6.147 20.201-6.147 8.083 0 20.084 1.85 21.426 7.025.1.567.14 1.144.116 1.72 0 20.782 3.919 35.651 5.832 41.423 3.66 10.882 8.635 14.697 12.588 17.727 3.693 2.831 6.493 4.978 6.493 11.566Zm-48.858-32.782c2.811 0 3.674-2.213 3.674-5.163 0-7.985-1.469-11.556-3.067-11.556-1.831 0-3.674 4.683-3.674 12.539 0 2.424.735 4.145 3.067 4.145v.035Zm13.786-38.144c-2.204 0-4.28-1.1-4.28-2.447 0-1.112 1.388-1.721 2.811-1.721 2.204 0 4.164 1.1 4.164 2.447 0 1.112-1.225 1.721-2.695 1.721ZM589.318 68c-9.396 0-18.922 2.31-18.922 7.183 0 1.688 1.144 3.517 2.493 5.676 1.471 2.353 3.187 5.099 3.936 8.481a68.095 68.095 0 0 1 1.307 14.958c.036 7.152-.627 14.29-1.978 21.317-.304 1.358-1.446 3.456-2.806 5.953-2.544 4.671-5.848 10.739-5.848 15.979 0 6.336 4.827 11.453 22.006 11.453 17.178 0 21.994-5.245 21.994-11.453 0-5.201-3.3-11.101-5.776-15.527-1.297-2.319-2.368-4.234-2.619-5.43a133.127 133.127 0 0 1-2.602-24.845 54.29 54.29 0 0 1 1.177-12.428c.774-3.369 2.519-6.12 4.014-8.475 1.372-2.163 2.533-3.992 2.533-5.659 0-4.862-9.514-7.183-18.909-7.183Zm9.148 8.274c-2.225 0-4.333-1.091-4.333-2.425 0-1.103 1.366-1.706 2.849-1.706 2.226 0 4.204 1.09 4.204 2.425 0 1.102-1.236 1.706-2.72 1.706Zm71.342 21.876a6.777 6.777 0 0 0 1.581.243c5.447 0 8.24-9.123 8.217-15.824 0-6.445-2.135-12.462-5.771-13.621a5.744 5.744 0 0 0-1.454-.244c-2.16 0-4.374-.394-6.671-.804-2.476-.441-5.049-.9-7.755-.9-16.111 0-32.834 12.775-32.834 25.064 0 10.486 12.226 18.395 21.296 24.262 5.348 3.46 9.599 6.209 9.599 8.359 0 1.705-2.689 3.652-6.924 3.652-6.256 0-9.778-3.979-13.035-7.657-2.8-3.163-5.403-6.103-9.378-6.103-6.544 0-10.179 8.033-10.179 16.797 0 21.424 11.876 27.626 29.683 27.626 29.326 0 41.317-16.937 41.317-32.008 0-16.715-14.708-22.85-25.505-27.354-6.261-2.612-11.207-4.675-11.207-7.934.341-3.592 3.441-6.276 7.029-6.086 4.059 0 5.774 3.495 7.409 6.827 1.243 2.532 2.439 4.969 4.582 5.705Zm-.589-21.424c-2.193 0-4.616-1.704-4.616-3.153 0-.974.969-1.426 2.054-1.46 2.193 0 4.616 1.704 4.616 3.153 0 .973-.969 1.46-2.054 1.46ZM756.187 68c6.213 0 11.313 1.464 11.313 4.52a4.664 4.664 0 0 1-.73 2.184c-1.253 1.918-3.681 3.895-6.52 6.207-2.939 2.393-6.319 5.145-9.29 8.56-.421.482-.884.989-1.375 1.527-2.5 2.737-5.724 6.267-7.759 11.162a35.08 35.08 0 0 0-2.19 13.048 58.132 58.132 0 0 0 1.159 11.34c.25 1.195 1.301 3.104 2.575 5.417 2.442 4.434 5.701 10.352 5.701 15.567 0 6.216-4.753 11.468-21.664 11.468s-21.663-5.124-21.663-11.468c0-5.238 3.247-11.302 5.75-15.975 1.344-2.511 2.474-4.621 2.769-5.985.519-2.446.806-4.936.858-7.436a32.283 32.283 0 0 0-4.509-15.976 97.983 97.983 0 0 0-8.021-12.688c-2.671-3.424-5.846-6.181-8.606-8.578-2.654-2.304-4.924-4.276-5.998-6.19a2.87 2.87 0 0 1-.487-1.58c0-3.416 7.059-5.124 15.207-5.124 9.273 0 22.266 2.196 24.828 6.704a9.308 9.308 0 0 1 .973 4.392c0 .66-.03 1.317-.061 1.988a45.18 45.18 0 0 0-.066 2.16c-.042 2.028.248 4.05.858 5.984 1.089 3.486 2.063 5.81 2.909 5.81.846 0 1.46-1.709 1.947-5.81.225-1.825.357-3.422.476-4.855.335-4.044.562-6.787 2.445-9.669C739.833 70.196 748.723 68 756.187 68Zm-41.495 9.144c0 1.104 1.588 1.952 3.535 1.952 1.948 0 3.478-.848 3.478-2.068 0-1.22-1.461-1.952-3.408-1.952-1.947 0-3.651.848-3.651 2.068h.046Zm44.973-3.044c0 1.092-1.53 1.952-3.478 1.952-1.993 0-3.477-.988-3.477-2.08s1.576-1.94 3.477-1.94c1.901 0 3.478.976 3.478 2.068Z'
				fill='#F7941D'
			/>
			<path
				d='M789.5 75c-2.907 9.984-8.36 22.707-11.907 28.174L770.5 104a160.176 160.176 0 0 0 7.479-27.925L789.5 75Z'
				fill='#F7941D'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M847.808 98.15a6.688 6.688 0 0 0 1.569.243c5.459 0 8.264-9.123 8.217-15.824 0-6.445-2.135-12.462-5.77-13.621a5.744 5.744 0 0 0-1.454-.244c-2.154 0-4.363-.394-6.657-.803-2.476-.442-5.05-.901-7.758-.901-16.111 0-32.834 12.775-32.834 25.064 0 10.486 12.226 18.395 21.296 24.262 5.348 3.46 9.599 6.209 9.599 8.359 0 1.705-2.689 3.652-6.924 3.652-6.256 0-9.778-3.979-13.035-7.657-2.8-3.163-5.403-6.103-9.378-6.103-6.544 0-10.179 8.033-10.179 16.797 0 21.424 11.876 27.626 29.683 27.626 29.314 0 41.317-16.937 41.317-32.008 0-16.715-14.708-22.85-25.505-27.354-6.261-2.612-11.207-4.675-11.207-7.934.341-3.592 3.441-6.276 7.029-6.086 4.059 0 5.774 3.495 7.409 6.827 1.243 2.532 2.439 4.969 4.582 5.705Zm-.554-21.424c-2.193 0-4.617-1.704-4.617-3.153 0-.974.935-1.426 2.055-1.46 2.192 0 4.616 1.704 4.616 3.153 0 .973-.969 1.46-2.054 1.46Z'
				fill='#F7941D'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M249.649 447.026c1.102.298 2.234.474 3.375.523 11.679 0 17.635-19.349 17.658-33.53 0-13.682-4.659-26.318-12.449-28.896a13.135 13.135 0 0 0-3.107-.511c-4.62 0-9.359-.837-14.276-1.705-5.299-.935-10.805-1.907-16.591-1.907-52.706 0-88.759 57.513-88.759 110.136 0 44.11 25.425 84.864 88.187 84.864 38.12 0 63.813-13.159 63.813-58.558 0-18.571-7.778-35.586-21.793-35.586-9.194 0-15.027 7.281-20.861 14.563-5.839 7.288-11.679 14.577-20.891 14.577-19.456 0-26.978-18.315-26.978-38.431 0-24.761 11.411-52.1 26.978-52.1 8.709 0 12.385 7.413 15.888 14.476 2.659 5.364 5.219 10.526 9.806 12.085Zm-1.296-45.399c-4.66 0-9.857-3.601-9.857-6.702 0-2.055 2.078-3.101 4.414-3.101 4.672 0 9.857 3.612 9.857 6.713 0 2.068-2.079 3.09-4.414 3.09Z'
				fill='url(#titleText__l)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M322.956 446.026a150.346 150.346 0 0 0-3.613-32.807c-1.558-6.902-4.956-12.557-7.942-17.528-2.937-4.89-5.477-9.117-5.477-13.219 0-9.563 19.866-14.472 39.5-14.472h45.412c52.383 0 68.113 27.653 68.113 46.767 0 20.716-12.697 28.87-18.882 32.841-1.991 1.279-3.307 2.124-3.307 2.815 0 1.485 1.883 3.794 4.846 7.425 5.81 7.121 15.769 19.327 23.802 40.378 2.608 6.747 7.826 10.33 12.991 13.878 7.099 4.876 14.101 9.685 14.101 22.546 0 21.964-18.588 26.35-42.578 26.35-29.415 0-45.157-4.898-45.157-24.803-.255-26.861-4.647-74.152-20.121-74.152-6.703 0-13.674 8.528-13.674 19.894a56.369 56.369 0 0 0 1.545 14.216c2.773 11.919 5.495 20.78 7.655 27.813v.001c2.664 8.672 4.474 14.566 4.474 19.988 0 11.878-13.163 17.043-39.22 17.043-35.863 0-45.924-11.098-45.924-24.535 0-9.533 4.193-16.969 8.702-24.967 3.558-6.311 7.314-12.971 9.363-21.288a195.794 195.794 0 0 0 5.391-44.184Zm67.857-41.078c-14.185 0-20.912 8.016-20.912 15.763 0 10.075 11.618 15.496 22.445 15.496 9.294 0 18.065-4.13 18.065-12.657.012-8.783-8.504-18.602-19.598-18.602Zm29.926-16.275c-4.635 0-9.805-3.618-9.805-6.713 0-2.071 2.068-3.106 4.392-3.106 4.647 0 9.805 3.618 9.805 6.724 0 2.059-2.068 3.095-4.392 3.095Z'
				fill='url(#titleText__m)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M538.82 383.776c19.544 0 39.366 4.89 39.366 14.414 0 4.07-2.517 8.268-5.465 13.186-3.011 5.022-6.472 10.794-8.162 17.948-1.54 6.175-2.061 15.178-2.061 26.765 0 30.612 5.407 56.868 30.346 56.868 24.176 0 31.366-26.766 31.366-59.185v-10.811c0-5.399 0-10.555-1.019-14.923-1.6-7.061-5.128-12.811-8.159-17.75-2.822-4.601-5.214-8.499-5.214-12.098 0-10.3 10.803-15.19 30.335-15.19 19.533 0 30.347 4.89 30.347 15.19 0 3.587-2.437 7.473-5.309 12.055h-.001c-3.104 4.951-6.718 10.716-8.318 17.793-1.54 6.685-2.061 15.7-2.061 25.734 0 10.565 1.61 22.083 3.113 32.835 1.316 9.411 2.549 18.234 2.549 25.318 0 43.485-42.434 64.075-73.545 64.075-35.997 0-77.401-27.808-77.401-61.502 0-5.247 1.021-12.768 2.197-21.42 1.591-11.718 3.465-25.511 3.465-38.542a120.74 120.74 0 0 0-2.316-25.734c-1.558-6.873-4.943-12.504-7.917-17.453-2.927-4.87-5.456-9.078-5.456-13.159-.023-9.524 19.776-14.414 39.32-14.414Zm17.483 17.241c4.122 0 7.457-1.807 7.457-4.125 0-2.317-3.335-4.368-7.457-4.368s-7.456 2.063-7.456 4.368c0 2.306 3.346 4.125 7.456 4.125Zm98.74-4.125c0 2.318-3.335 4.125-7.456 4.125-4.111 0-7.457-1.819-7.457-4.125 0-2.305 3.335-4.368 7.457-4.368 4.121 0 7.456 2.051 7.456 4.368Z'
				fill='url(#titleText__n)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M727.965 368c-19.666 0-39.565 4.909-39.565 15.252 0 3.629 2.417 7.562 5.272 12.207 3.038 4.942 6.571 10.691 8.215 17.737 2.059 8.784 2.839 20.149 2.839 31.783 0 16.019-1.548 32.806-4.131 45.208-.631 2.901-3.034 7.379-5.892 12.705-5.314 9.903-12.203 22.739-12.203 33.829 0 13.437 10.077 24.279 46 24.279s46-11.098 46-24.279c0-10.992-6.86-23.418-12.037-32.794-2.735-4.954-4.999-9.056-5.534-11.646a287.982 287.982 0 0 1-5.423-52.712c0-9.562.512-18.858 2.327-26.35 1.608-7.105 5.24-12.893 8.36-17.864 2.888-4.601 5.337-8.503 5.337-12.103 0-10.343-19.899-15.252-39.565-15.252Zm19.096 17.578c-4.655 0-9.042-2.326-9.042-5.177h-.035c0-2.326 2.839-3.618 5.981-3.618 4.643 0 8.786 2.327 8.786 5.177 0 2.315-2.583 3.618-5.69 3.618Z'
				fill='url(#titleText__o)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M897.649 433.038c1.102.294 2.234.466 3.375.511 11.667 0 17.635-19.338 17.612-33.53 0-13.67-4.672-26.306-12.45-28.884a12.684 12.684 0 0 0-3.106-.523c-4.621 0-9.36-.837-14.276-1.705-5.3-.935-10.806-1.907-16.592-1.907-34.499 0-70.294 27.084-70.294 53.134 0 22.202 26.099 38.903 45.507 51.322 11.487 7.351 20.63 13.202 20.63 17.805 0 3.612-5.7 7.747-14.774 7.747-13.394 0-20.934-8.428-27.905-16.22-5.994-6.701-11.568-12.932-20.083-12.932-14.003 0-21.793 17.015-21.793 35.598 0 45.399 25.425 58.546 63.556 58.546 62.751 0 88.444-35.853 88.444-67.838 0-35.423-31.486-48.426-54.601-57.973-13.407-5.536-23.998-9.91-23.998-16.821 0-4.39 4.415-12.903 15.054-12.903 8.709 0 12.385 7.417 15.887 14.483 2.66 5.366 5.22 10.53 9.807 12.09Zm-1.296-45.4c-4.672 0-9.857-3.612-9.857-6.701 0-2.067 2.078-3.101 4.414-3.101 4.672 0 9.857 3.612 9.857 6.713 0 2.056-2.079 3.089-4.414 3.089Z'
				fill='url(#titleText__p)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M963.994 443.672c1.819 7.498 2.332 16.021 2.332 25.335 0 17.267-2.332 36.152-5.691 49.401-2.058 8.332-5.83 15-9.403 21.316-4.525 8.002-8.732 15.439-8.732 24.977 0 13.704 10.881 24.299 46.102 24.299h82.378c19.42 0 36.52-35.418 36.52-62.313 0-16.545-6.46-29.737-22.79-29.737-8.87 0-13.85 5.933-19.32 12.452-6.67 7.95-14.07 16.772-30.15 16.772-8.81 0-19.94-14.74-19.94-24.31 0-4.914 2.84-8.279 10.1-8.279 6 0 10.36 3.305 14.02 6.082 2.65 2.011 4.93 3.745 7.21 3.745 5.71 0 10.1-10.083 10.1-22.238s-4.39-21.982-10.1-21.982c-2.3 0-4.64 1.714-7.35 3.691-3.69 2.695-8.06 5.879-13.88 5.879-8.3 0-11.92-4.144-11.92-9.314 0-9.827 12.7-23.798 30.32-23.798 18.32 0 25.58 9.043 31.68 16.642 4.42 5.506 8.24 10.253 15.2 10.253 8.54 0 12.17-9.827 12.17-20.69 0-19.385-12.68-40.855-24.34-40.855h-88.334c-19.698 0-39.652 2.329-39.652 12.679 0 3.614 2.408 7.528 5.251 12.148 3.055 4.965 6.612 10.746 8.219 17.845Zm112.936-27.152c-4.66 0-9.84-3.621-9.84-6.718v-.058c0-2.073 2.06-3.109 4.4-3.051 4.66 0 9.84 3.621 9.84 6.718 0 2.073-2.06 3.109-4.4 3.109Z'
				fill='url(#titleText__q)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M184.465 59c-31.232 0-62.872 7.807-62.872 23.025 0 6.526 4.044 13.252 8.723 21.034 4.754 7.908 10.164 16.905 12.649 27.889 3.279 14.392 4.512 30.006 4.512 46.457a326.417 326.417 0 0 1-8.21 71.949c-3.262 13.236-9.244 23.834-14.911 33.876-7.181 12.722-13.856 24.549-13.856 39.713 0 21.372 16.023 39.057 73.14 39.057h73.965c99.43 0 131.895-49.75 131.895-91.273 0-29.238-16.035-55.916-45.616-71.123-5.744-2.874-8.21-6.166-8.21-9.459 0-3.7 3.698-7.807 9.442-11.506 13.558-9.052 20.14-24.259 20.14-41.524 0-34.125-25.07-78.115-108.477-78.115h-72.314Zm39.035 83.874c0-12.286 10.674-25.084 33.279-25.084 17.663 0 31.221 15.625 31.221 29.598 0 13.566-13.965 20.151-28.756 20.151-17.256 0-35.744-8.633-35.744-24.665Zm69.802 103.187c0-18.092-13.558-37.417-36.162-37.417-20.931 0-32.454 18.511-32.454 36.591 0 16.859 10.267 32.891 32.454 32.891 25.116 0 36.162-15.625 36.162-32.065Zm11.093-154.17c-7.395 0-15.616-5.76-15.616-10.692h.047c0-3.293 3.314-4.933 6.93-4.933 7.395 0 15.616 5.759 15.616 10.692 0 3.293-3.279 4.933-6.977 4.933Z'
				fill='url(#titleText__r)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M405.5 258.63c0-44.26 30.356-92.63 74.605-92.63 44.063 0 74.395 48.161 74.395 92.409 0 37.316-21.821 71.591-74.827 71.591-52.796.012-74.173-34.217-74.173-71.37Zm97.337-15.605c0-20.83-9.807-43.819-22.907-43.819s-22.685 22.989-22.685 43.819c0 16.917 6.328 32.324 22.685 32.324s22.907-15.407 22.907-32.324Zm-.654-59.656c-3.923 0-8.289-3.041-8.289-5.642h-.047c0-1.742 1.751-2.601 3.759-2.601 3.923 0 8.29 3.03 8.29 5.631 0 1.742-1.74 2.612-3.713 2.612Z'
				fill='url(#titleText__s)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M556.5 296.63c0-44.249 30.358-92.63 74.611-92.63 44.066 0 74.389 48.161 74.389 92.421 0 37.304-21.811 71.579-74.821 71.579-52.8 0-74.179-34.275-74.179-71.37Zm97.298-15.617c0-20.829-9.82-43.818-22.909-43.818-13.089 0-22.687 22.989-22.687 43.818 0 16.917 6.329 32.324 22.687 32.324s22.909-15.407 22.909-32.324Zm-.654-59.667c-3.923 0-8.29-3.042-8.29-5.642 0-1.719 1.751-2.59 3.713-2.601 3.923 0 8.29 3.03 8.29 5.642 0 1.73-1.751 2.601-3.713 2.601Z'
				fill='url(#titleText__t)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M803.673 287.229c-7.132 0-9.722-4.164-9.722-10.469 0-18.232 13.97-37.154 26.186-53.701 9.48-12.841 17.904-24.252 17.924-32.801 0-6.944-13.397-8.258-28.077-8.258h-78.602c-9.71 0-20.298 18.063-20.298 34.347 0 9.119 3.028 17.378 10.149 17.378 5.712 0 8.962-4.034 12.586-8.529l.129-.16c1.942-2.396 12.738-13.481 26.99-13.481 7.132 0 11.444 2.617 11.444 8.049 0 3.44-1.974 8.119-4.433 13.946-.8 1.896-1.651 3.913-2.503 6.048-5.233 12.908-17.362 29.307-28.994 45.033-13.827 18.696-26.952 36.44-26.952 46.238 0 7.386 14.472 9.131 33.915 9.131h68.627c16.206 0 30.458-29.741 30.458-52.341 0-13.911-5.398-24.996-13.397-24.996-6.313 0-10.267 6.748-14.029 13.171-3.417 5.832-6.676 11.395-11.401 11.395Zm16.46-100.03c3.19 0 5.78 1.536 5.78 3.49v.011c0 2.827-3.884 3.908-6.427 3.897-3.248 0-5.838-1.536-5.838-3.49 0-2.826 3.896-3.908 6.485-3.908Z'
				fill='url(#titleText__u)'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M903.12 125.676c2.831 11.712 3.635 25.075 3.635 39.624 0 27.098-3.635 56.616-8.9 77.306-3.215 13.014-9.107 23.423-14.69 33.288-7.081 12.51-13.665 24.142-13.665 39.098 0 21.423 17.008 38.008 72.098 38.008h128.822c30.36 0 57.08-55.395 57.08-97.45 0-25.9-10.12-46.52-35.64-46.52-13.86 0-21.64 9.274-30.19 19.466-10.44 12.432-22.02 26.229-47.17 26.229-13.77 0-31.185-23.051-31.185-38.008 0-7.687 4.45-12.944 15.797-12.944 9.388 0 16.198 5.165 21.918 9.505 4.15 3.146 7.72 5.858 11.29 5.858 8.92 0 15.8-15.77 15.8-34.774s-6.88-34.367-15.8-34.367c-3.59 0-7.27 2.678-11.5 5.769-5.78 4.211-12.6 9.187-21.708 9.187-12.966 0-18.639-6.408-18.639-14.549 0-15.375 19.847-37.217 47.387-37.217 28.66 0 40.02 14.146 49.56 26.029 6.91 8.606 12.87 16.026 23.75 16.026 13.38 0 19.05-15.364 19.05-32.355 0-30.32-19.85-63.885-38.08-63.885H944.021c-30.777 0-61.963 3.594-61.963 19.771 0 5.654 3.766 11.778 8.211 19.007 4.773 7.763 10.33 16.8 12.851 27.898Zm176.59-42.508c-7.24 0-15.4-5.618-15.4-10.468 0-3.233 3.21-4.85 6.9-4.85 7.23 0 15.39 5.618 15.39 10.468 0 3.233-3.24 4.85-6.89 4.85Z'
				fill='url(#titleText__v)'
			/>
			<path
				d='M328.5 389s27.163 103.674 5.817 139M259.5 511.69s-7.9 63.634-74.246 24.694c-66.345-38.94-9.478-134.38 22.761-131.312'
				stroke='#fff'
				strokeWidth='4'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeDasharray='5'
			/>
			<path
				clipRule='evenodd'
				d='M570.5 542.592 586.825 566l21.675-22.781V526h-37.791l-.209 16.592v0Z'
				stroke='#fff'
				strokeWidth='4'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeDasharray='5'
			/>
			<path
				d='M536.268 408s-17.395 89.32 8.232 119m95.894-106s11.549 108.937-9.894 106.974M425.505 465s-1.419 70.163 43.995 70m338-39.94s.234 48.729 58.422 32.706c58.189-16.022 30.964-59.623 4.919-76.69-26.044-17.066-54.145-49.993-10.516-65.076m180.585 32h-55.192s17.132 115.454 0 128.863c-17.128 13.408 69.762 40.665 95.782-17.99M728 401v128'
				stroke='#fff'
				strokeWidth='4'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeDasharray='5'
			/>
			<defs>
				<linearGradient id='titleText__a' x1='850.5' y1='709' x2='1111.5' y2='709' gradientUnits='userSpaceOnUse'>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__b'
					x1='734.5'
					y1='682.008'
					x2='901.5'
					y2='682.008'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__c'
					x1='617.477'
					y1='681.023'
					x2='786.477'
					y2='681.023'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient id='titleText__d' x1='453.5' y1='696' x2='668.5' y2='696' gradientUnits='userSpaceOnUse'>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient id='titleText__e' x1='344.535' y1='681' x2='505.535' y2='681' gradientUnits='userSpaceOnUse'>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__f'
					x1='248.5'
					y1='681.047'
					x2='397.5'
					y2='681.047'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__g'
					x1='216.169'
					y1='749.32'
					x2='312.129'
					y2='529.267'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__h'
					x1='144.312'
					y1='191.009'
					x2='5.16'
					y2='153.381'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__i'
					x1='49.432'
					y1='612.775'
					x2='218.423'
					y2='521.616'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__j'
					x1='156.149'
					y1='47.564'
					x2='-40.81'
					y2='-9.839'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__k'
					x1='-107.577'
					y1='245.451'
					x2='-63.574'
					y2='1071.65'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' />
					<stop offset='.52' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__l'
					x1='97.235'
					y1='273.094'
					x2='97.235'
					y2='566.349'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient
					id='titleText__m'
					x1='249.098'
					y1='272.256'
					x2='249.098'
					y2='566.002'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient
					id='titleText__n'
					x1='455.363'
					y1='273.552'
					x2='455.363'
					y2='566.117'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient
					id='titleText__o'
					x1='658.406'
					y1='272.256'
					x2='658.406'
					y2='566.002'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient
					id='titleText__p'
					x1='745.223'
					y1='272.578'
					x2='745.223'
					y2='565.833'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient
					id='titleText__q'
					x1='895.99'
					y1='272.088'
					x2='895.99'
					y2='566.075'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#26A9E0' />
					<stop offset='.59' stopColor='#1B75BB' />
					<stop offset='1' stopColor='#2B388F' />
				</linearGradient>
				<linearGradient
					id='titleText__r'
					x1='.579'
					y1='-45.284'
					x2='27.475'
					y2='461.652'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' stopOpacity='.6' />
					<stop offset='.23' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__s'
					x1='235.334'
					y1='-54.906'
					x2='263.071'
					y2='450.936'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' stopOpacity='.6' />
					<stop offset='.23' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__t'
					x1='384.319'
					y1='-61.548'
					x2='412.058'
					y2='444.294'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' stopOpacity='.6' />
					<stop offset='.23' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__u'
					x1='545.222'
					y1='-67.206'
					x2='577.175'
					y2='439.218'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' stopOpacity='.6' />
					<stop offset='.23' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
				<linearGradient
					id='titleText__v'
					x1='759.149'
					y1='-77.7'
					x2='788.79'
					y2='428.863'
					gradientUnits='userSpaceOnUse'
				>
					<stop offset='.01' stopColor='#fff' stopOpacity='.6' />
					<stop offset='.23' stopColor='#A8DBEE' />
					<stop offset='1' stopColor='#26A9E0' />
				</linearGradient>
			</defs>
		</SvgIcon>
	);
};

export const BubbleMachine: React.FC<{ minSize?: number }> = ({ minSize = 60 }) => {
	const particlesInit = React.useCallback(async (engine: Engine) => {
		// you can initialize the tsParticles instance (engine) here, adding custom shapes or presets
		// this loads the tsparticles package bundle, it's the easiest method for getting everything ready
		// starting from v2 you can add only the features you need reducing the bundle size
		await loadFull(engine);
		await loadBubblesPreset(engine);
		await loadEmittersPlugin(engine);
	}, []);

	const particleOptions = React.useRef<ISourceOptions>({
		autoPlay: true,
		background: {
			color: 'transparent',
		},
		detectRetina: true,
		emitters: [
			{
				direction: 'top',
				life: {
					count: 50,
					delay: 5,
					duration: 3,
				},
				position: {
					x: '75%',
					y: '100%',
				},
			},
			{
				direction: 'top',
				life: {
					count: 50,
					delay: 5,
					duration: 3,
				},
				position: {
					x: '25%',
					y: '100%',
				},
			},
		],
		fpsLimit: 30,
		interactivity: {
			events: {
				onclick: {
					enable: true,
					mode: 'push',
				},
				resize: true,
			},
		},
		particles: {
			collisions: {
				enable: true,
			},
			number: {
				density: {
					area: 2,
				},
				max: 40,
			},
			shape: {
				images: [
					{
						height: 60,
						replaceColor: false,
						src: BubbleImageUrl,
						width: 60,
					},
				],
				type: 'images',
			},
			size: {
				random: { enable: true, minimumValue: minSize },
			},
		},
		preset: 'bubbles',
	}).current;
	return <Particles init={particlesInit} options={particleOptions} />;
};
